// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Avatar,
//   Tabs,
//   Tab,
//   Card,
//   CardContent,
//   Chip,
//   Stack,
//   Divider,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   MenuItem,
//   Alert,
//   CircularProgress,
//   FormControlLabel,
//   Checkbox,
//   RadioGroup,
//   Radio,
// } from "@mui/material";
// import {
//   ChevronRight as ChevronRightIcon,
//   UploadFile as UploadFileIcon,
//   Edit as EditIcon,
//   Save as SaveIcon,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import { useNavigate, useLocation } from "react-router-dom";
// import StyledDataGrid from "../../components/StyledDataGrid";
// import RecordProfilePage from "../../components/RecordProfilePage";
// import { BASE_CHIP_SX, STATUS_CHIP_STYLES } from "../../constants/statusColors";
// import { US_STATES } from "../../constants/patientOptions";
// import { BIOBANK_SUB_ROUTES } from "../../constants/routes";
// import {
//   fetchConsentOverview,
//   fetchStudies,
//   fetchPatientActivity,
//   fetchPatientSampleHistory,
//   parseConsentPdfMetadata,
//   patchConsent,
//   revokeConsent,
//   updatePatient,
//   fetchPatientById,
// } from "../../utils/api";
// import { submitConsents } from "../../utils/apiConsent";
// import {
//   chicagoDateTimeLocalToIso,
//   formatDateTimeInAppTimeZone,
//   formatDateInAppTimeZone,
//   isoToChicagoDateTimeLocal,
//   nowIso,
// } from "../../utils/appDateTime";

// const samplePatient = {
//   id: "2d7d1bfd-8bd8-4252-9bfe-8c43485d917c",
//   name: "Hayley Johnston",
//   initials: "HJ",
//   dateOfBirth: "1996-01-19T00:00:00.000Z",
//   activeSince: "April 2025",
//   irbStudies: [
//     { id: "STUDY2023-0042", name: "IPGx Registry" },
//     { id: "STUDY2024-0008", name: "TREC Registry and Repository" },
//   ],
//   lastVisit: "2025-09-19T00:00:00.000Z",
//   email: "hayley.johnston@example.com",
//   mobilePhoneNumber: "555-123-4567",
//   gender: "FEMALE",
//   homeAddressLine1: "123 Main St",
//   homeAddressLine2: "",
//   city: "Chicago",
//   state: "IL",
//   zipCode: "60601",
// };

// const GENDER_OPTIONS = [
//   { value: "MALE", label: "Male" },
//   { value: "FEMALE", label: "Female" },
//   { value: "OTHER", label: "Other" },
//   { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
// ];

// const parseMetadataJson = (metadataJson) => {
//   if (!metadataJson) {
//     return {};
//   }
//   try {
//     return JSON.parse(metadataJson);
//   } catch (error) {
//     console.warn("Unable to parse consent signature metadata JSON:", error);
//     return {};
//   }
// };

// const formatDateTime = (value) => {
//   if (!value) {
//     return "Not captured";
//   }
//   return formatDateTimeInAppTimeZone(value, value);
// };

// const formatDateOnly = (value) => {
//   if (!value) {
//     return "N/A";
//   }
//   if (typeof value === "string") {
//     const isoDateMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
//     if (isoDateMatch) {
//       return isoDateMatch[1];
//     }
//   }
//   return formatDateInAppTimeZone(value, value);
// };

// const formatActiveSince = (value) => {
//   if (!value) {
//     return "N/A";
//   }
//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) {
//     return "N/A";
//   }
//   return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
// };

// const toDateTimeLocalValue = (value) => {
//   if (!value) {
//     return "";
//   }
//   return isoToChicagoDateTimeLocal(value);
// };

// const normalizePersonName = (value) =>
//   (value || "")
//     .toLowerCase()
//     .replace(/[^a-z\s]/g, " ")
//     .replace(/\s+/g, " ")
//     .trim();

// const namesMatch = (left, right) => {
//   const normalizedLeft = normalizePersonName(left);
//   const normalizedRight = normalizePersonName(right);
//   return Boolean(
//     normalizedLeft && normalizedRight && normalizedLeft === normalizedRight,
//   );
// };

// const getConsentKey = (item) => item?.currentConsentId || item?.consentName;

// const emptyContactInfo = {
//   email: "",
//   mobilePhoneNumber: "",
//   homeAddressLine1: "",
//   homeAddressLine2: "",
//   city: "",
//   state: "",
//   zipCode: "",
// };

// const PatientProfile = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [tabValue, setTabValue] = useState(0);
//   const [patient, setPatient] = useState(null);
//   const [subTabValue, setSubTabValue] = useState(0);
//   const [consentOverview, setConsentOverview] = useState({
//     studyConsent: { active: [], inactive: [] },
//     generalConsent: { active: [], inactive: [] },
//     survey: []
//   });
//   const [loadingConsents, setLoadingConsents] = useState(false);
//   const [patientActivity, setPatientActivity] = useState([]);
//   const [loadingActivity, setLoadingActivity] = useState(false);
//   const [sampleHistory, setSampleHistory] = useState([]);
//   const [loadingSampleHistory, setLoadingSampleHistory] = useState(false);
//   const [uploadingConsentId, setUploadingConsentId] = useState(null);
//   const [reviewDialogOpen, setReviewDialogOpen] = useState(false);
//   const [selectedConsent, setSelectedConsent] = useState(null);
//   const [parsedConsentMetadata, setParsedConsentMetadata] = useState(null);
//   const [reviewValues, setReviewValues] = useState({
//     signerName: "",
//     signedDate: "",
//     irbStudy: "",
//     protocolName: "",
//   });
//   const [mismatchAcknowledged, setMismatchAcknowledged] = useState(false);
//   const [savingConsentMetadata, setSavingConsentMetadata] = useState(false);
//   const [consentActionError, setConsentActionError] = useState("");
//   const [consentActionSuccess, setConsentActionSuccess] = useState("");
//   const [revokeDialogOpen, setRevokeDialogOpen] = useState(false);
//   const [revokeTarget, setRevokeTarget] = useState(null);
//   const [revokeReason, setRevokeReason] = useState("");
//   const [revokeReasonError, setRevokeReasonError] = useState("");

//   const [contactInfo, setContactInfo] = useState(emptyContactInfo);
//   const [editingContact, setEditingContact] = useState(false);
//   const [savingContact, setSavingContact] = useState(false);
//   const [contactError, setContactError] = useState("");
//   const [contactSuccess, setContactSuccess] = useState("");
//   const [loadingContactInfo, setLoadingContactInfo] = useState(false);

//   const [confirmSignModalOpen, setConfirmSignModalOpen] = useState(false);
//   const [consentToSign, setConsentToSign] = useState(null);
//   const [isSigningConsent, setIsSigningConsent] = useState(false);

//   const handleOpenSignModal = (item) => {
//     setConsentToSign(item);
//     setConfirmSignModalOpen(true);
//   };

//   const handleConfirmSign = async () => {
//     if (!consentToSign) return;
//     try {
//       setIsSigningConsent(true);

//       const formId = consentToSign.availableForms?.[0]?.consentFormId || consentToSign.id;
//       if (!formId) throw new Error("Consent form ID is missing.");

//       const consentsToSubmit = [{
//         consentFormId: formId,
//         consentDate: new Date().toISOString()
//       }];

//       await submitConsents(patient?.id || patient?.patientId, consentsToSubmit);

//       setConsentActionSuccess(`Successfully signed consent form.`);
//       setTimeout(() => setConsentActionSuccess(""), 1000);
//       setConfirmSignModalOpen(false);
//       setConsentToSign(null);
//       // Reload profile data
//       loadPatientConsents(patient);
//     } catch (err) {
//       console.error("Error signing consent:", err);
//       setConsentActionError(err.message || "Failed to sign consent. Please try again.");
//     } finally {
//       setIsSigningConsent(false);
//     }
//   };

//   const loadPatientConsents = useCallback(async (patientData) => {
//     if (!patientData?.id) {
//       setConsentOverview({
//         studyConsent: { active: [], inactive: [] },
//         generalConsent: { active: [], inactive: [] },
//         survey: []
//       });
//       return;
//     }
//     try {
//       setLoadingConsents(true);
//       const overview = await fetchConsentOverview(patientData.id);
//       if (overview) {
//         setConsentOverview(overview);
//       }
//     } catch (error) {
//       console.error("❌ Error loading consent overview:", error);
//     } finally {
//       setLoadingConsents(false);
//     }
//   }, []);

//   useEffect(() => {
//     const loadData = async () => {
//       let transformedPatient;
//       let patientId = null;

//       if (location.state?.patient) {
//         const patientData = location.state.patient;
//         patientId = patientData.id;
//         transformedPatient = {
//           id: patientData.id,
//           name: patientData.name,
//           initials: patientData.name
//             ? patientData.name
//                 .split(" ")
//                 .map((n) => n[0])
//                 .join("")
//             : "XX",
//           dateOfBirth: patientData.dateOfBirth,
//           activeSince: formatActiveSince(patientData.consentDate),
//           irbStudies: Array.isArray(patientData.irbStudies)
//             ? patientData.irbStudies.map((study) => {
//                 const normalizedStudy =
//                   typeof study === "string"
//                     ? { irbStudy: study, status: null }
//                     : study;
//                 return {
//                   id: normalizedStudy.irbStudy,
//                   name: normalizedStudy.irbStudy,
//                   status: normalizedStudy.status || null,
//                 };
//               })
//             : [],
//           lastVisit:
//             patientData.lastVisit !== "N/A" ? patientData.lastVisit : null,
//           email: patientData.email || "",
//           mobilePhoneNumber: patientData.mobilePhoneNumber || "",
//           gender: (patientData.gender || "").toUpperCase(),
//           homeAddressLine1: patientData.homeAddressLine1 || "",
//           homeAddressLine2: patientData.homeAddressLine2 || "",
//           city: patientData.city || "",
//           state: patientData.state || "",
//           zipCode: patientData.zipCode || "",
//         };
//       } else {
//         transformedPatient = samplePatient;
//         patientId = samplePatient.id;
//       }

//       setPatient(transformedPatient);
//       await loadPatientConsents(transformedPatient);

//       if (patientId) {
//         try {
//           setLoadingContactInfo(true);
//           const fullPatient = await fetchPatientById(patientId);
//           if (fullPatient) {
//             setPatient((prev) => ({
//               ...prev,
//               dateOfBirth: fullPatient.birthDate || prev.dateOfBirth,
//               activeSince: fullPatient.consentDate
//                 ? formatActiveSince(fullPatient.consentDate)
//                 : prev.activeSince,
//               email: fullPatient.email || prev.email || "",
//               mobilePhoneNumber:
//                 fullPatient.mobilePhoneNumber ||
//                 prev.mobilePhoneNumber ||
//                 "",
//               gender: (fullPatient.gender || prev.gender || "").toUpperCase(),
//               homeAddressLine1:
//                 fullPatient.homeAddressLine1 || prev.homeAddressLine1 || "",
//               homeAddressLine2:
//                 fullPatient.homeAddressLine2 || prev.homeAddressLine2 || "",
//               city: fullPatient.city || prev.city || "",
//               state: fullPatient.state || prev.state || "",
//               zipCode: fullPatient.zipCode || prev.zipCode || "",
//             }));
//           }
//         } catch (error) {
//           console.error("Error loading full patient record:", error);
//         } finally {
//           setLoadingContactInfo(false);
//         }
//       }
//     };

//     loadData();
//   }, [location.state, loadPatientConsents]);

//   useEffect(() => {
//     if (patient) {
//       setContactInfo({
//         email: patient.email || "",
//         mobilePhoneNumber: patient.mobilePhoneNumber || "",
//         homeAddressLine1: patient.homeAddressLine1 || "",
//         homeAddressLine2: patient.homeAddressLine2 || "",
//         city: patient.city || "",
//         state: patient.state || "",
//         zipCode: patient.zipCode || "",
//       });
//     }
//   }, [patient]);

//   useEffect(() => {
//     const allActive = [
//       ...consentOverview.studyConsent.active,
//       ...consentOverview.generalConsent.active
//     ];

//     if (allActive.length === 0) {
//       return;
//     }
//     const signedDates = allActive
//       .filter((item) => item.signed && item.activeRecord?.consentDate)
//       .map((item) => new Date(item.activeRecord.consentDate))
//       .filter((date) => !Number.isNaN(date.getTime()));

//     if (signedDates.length === 0) {
//       return;
//     }

//     const earliestSignDate = new Date(
//       Math.min(...signedDates.map((date) => date.getTime())),
//     );

//     setPatient((prev) =>
//       prev
//         ? { ...prev, activeSince: formatActiveSince(earliestSignDate.toISOString()) }
//         : prev,
//     );
//   }, [consentOverview]);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//     if (
//       newValue === 2 &&
//       patient?.id &&
//       patientActivity.length === 0 &&
//       !loadingActivity
//     ) {
//       loadPatientActivity(patient.id);
//     }
//     if (
//       newValue === 3 &&
//       patient?.id &&
//       sampleHistory.length === 0 &&
//       !loadingSampleHistory
//     ) {
//       loadSampleHistory(patient.id);
//     }
//   };

//   const loadPatientActivity = useCallback(async (patientId) => {
//     if (!patientId) return;
//     try {
//       setLoadingActivity(true);
//       const data = await fetchPatientActivity(patientId);
//       setPatientActivity(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Error loading patient activity:", error);
//       setPatientActivity([]);
//     } finally {
//       setLoadingActivity(false);
//     }
//   }, []);

//   const loadSampleHistory = useCallback(async (patientId) => {
//     if (!patientId) return;
//     try {
//       setLoadingSampleHistory(true);
//       const data = await fetchPatientSampleHistory(patientId);
//       setSampleHistory(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Error loading sample history:", error);
//       setSampleHistory([]);
//     } finally {
//       setLoadingSampleHistory(false);
//     }
//   }, []);

//   const handleSubTabChange = (newValue) => {
//     setSubTabValue(newValue);
//   };

//   const handleContactFieldChange = (field) => (event) => {
//     setContactInfo((prev) => ({
//       ...prev,
//       [field]: event.target.value,
//     }));
//   };

//   const handleEditContact = () => {
//     setContactError("");
//     setContactSuccess("");
//     setEditingContact(true);
//   };

//   const handleCancelContactEdit = () => {
//     setContactInfo({
//       email: patient?.email || "",
//       mobilePhoneNumber: patient?.mobilePhoneNumber || "",
//       homeAddressLine1: patient?.homeAddressLine1 || "",
//       homeAddressLine2: patient?.homeAddressLine2 || "",
//       city: patient?.city || "",
//       state: patient?.state || "",
//       zipCode: patient?.zipCode || "",
//     });
//     setContactError("");
//     setEditingContact(false);
//   };

//   const handleSaveContactInfo = async () => {
//     if (!patient?.id) {
//       setContactError("Unable to save contact information for this patient.");
//       return;
//     }

//     try {
//       setSavingContact(true);
//       setContactError("");
//       setContactSuccess("");

//       await updatePatient(patient.id, contactInfo);

//       setPatient((prev) => ({ ...prev, ...contactInfo }));
//       setContactSuccess("Contact information updated successfully.");
//       setEditingContact(false);
//     } catch (error) {
//       console.error("Error updating contact information:", error);
//       setContactError(
//         error.message || "Failed to update contact information.",
//       );
//     } finally {
//       setSavingContact(false);
//     }
//   };

//   const handleConsentPdfSelected = async (item, event) => {
//     const file = event.target.files?.[0];
//     event.target.value = "";
//     if (!file) {
//       return;
//     }

//     if (!item?.currentConsentId && item.consentType !== "GENERAL") {
//       setConsentActionError(
//         "A consent record is required before uploading signed PDF metadata.",
//       );
//       return;
//     }

//     try {
//       setConsentActionError("");
//       setConsentActionSuccess("");
//       setUploadingConsentId(getConsentKey(item));

//       const metadata = await parseConsentPdfMetadata(file);

//       const recommendedPatch = metadata?.recommendedConsentPatch || {};
//       setSelectedConsent(item);
//       setParsedConsentMetadata(metadata);
//       setReviewValues({
//         signerName:
//           recommendedPatch.extractedSignerName ||
//           metadata?.primarySignerName ||
//           "",
//         signedDate: toDateTimeLocalValue(
//           recommendedPatch.extractedSignedDate ||
//           metadata?.signedDate ||
//           item.activeRecord?.extractedSignedDate ||
//           item.activeRecord?.consentDate,
//         ),
//         irbStudy:
//           metadata?.irbStudy ||
//           item.irbStudy ||
//           "",
//         protocolName:
//           metadata?.protocolName ||
//           (item.activeRecord?.signatureMetadata && parseMetadataJson(item.activeRecord.signatureMetadata)?.protocolName) ||
//           "",
//       });
//       setMismatchAcknowledged(false);
//       setReviewDialogOpen(true);
//     } catch (error) {
//       console.error("Error parsing consent PDF metadata:", error);
//       setConsentActionError(
//         error.message || "Failed to parse consent PDF metadata.",
//       );
//     } finally {
//       setUploadingConsentId(null);
//     }
//   };

//   const handleReviewValueChange = (field) => (event) => {
//     setReviewValues((prev) => ({
//       ...prev,
//       [field]: event.target.value,
//     }));
//     if (field === "signerName") {
//       setMismatchAcknowledged(false);
//     }
//   };

//   const handleCloseReviewDialog = () => {
//     if (savingConsentMetadata) {
//       return;
//     }
//     setReviewDialogOpen(false);
//     setSelectedConsent(null);
//     setParsedConsentMetadata(null);
//     setMismatchAcknowledged(false);
//   };

//   const buildConfirmedSignatureMetadata = (
//     signedDateIso,
//     signerMatchesPatient,
//   ) => {
//     const baseMetadata = parseMetadataJson(parsedConsentMetadata?.metadataJson);
//     const confirmedMetadata = {
//       ...baseMetadata,
//       primarySignerName: reviewValues.signerName || null,
//       signedDate: signedDateIso,
//       irbStudy: reviewValues.irbStudy || null,
//       protocolName: reviewValues.protocolName || null,
//       userConfirmed: true,
//       userConfirmedAt: nowIso(),
//       signerMatchesPatient,
//       mismatchAcknowledged,
//     };

//     if (!confirmedMetadata.source) {
//       confirmedMetadata.source = "patient-profile-upload";
//     }
//     if (!confirmedMetadata.sourceType) {
//       confirmedMetadata.sourceType =
//         parsedConsentMetadata?.sourceType ||
//         selectedConsent?.activeRecord?.signatureSourceType ||
//         "MANUAL_ENTRY";
//     }
//     if (!Array.isArray(confirmedMetadata.signers)) {
//       confirmedMetadata.signers = [];
//     }

//     return JSON.stringify(confirmedMetadata);
//   };

//   const handleConfirmConsentMetadata = async () => {
//     if (!selectedConsent?.currentConsentId && selectedConsent?.consentType !== "GENERAL") {
//       setConsentActionError(
//         "Unable to save metadata because no consent record is selected.",
//       );
//       return;
//     }

//     const signerMatchesPatient = namesMatch(
//       reviewValues.signerName,
//       patient?.name,
//     );
//     if (!signerMatchesPatient && !mismatchAcknowledged) {
//       setConsentActionError(
//         "Signer name does not match the participant. Please acknowledge the mismatch before saving.",
//       );
//       return;
//     }

//     if (
//       !reviewValues.signerName ||
//       !reviewValues.signedDate ||
//       !reviewValues.irbStudy
//     ) {
//       setConsentActionError(
//         "Signer name, signed date, and IRB study are required.",
//       );
//       return;
//     }

//     try {
//       setSavingConsentMetadata(true);
//       setConsentActionError("");
//       setConsentActionSuccess("");

//       const signedDateIso = chicagoDateTimeLocalToIso(reviewValues.signedDate);
//       if (!signedDateIso) {
//         setConsentActionError("Signed date is invalid.");
//         return;
//       }

//       const signatureSourceType = parsedConsentMetadata?.requiresManualEntry
//         ? "MANUAL_ENTRY"
//         : parsedConsentMetadata?.sourceType || "ADOBE_ESIGNED";

//       const patchData = {
//         signatureSourceType,
//         extractedSignerName: reviewValues.signerName,
//         extractedSignedDate: signedDateIso,
//         consentDate: signedDateIso,
//         signatureMetadata: buildConfirmedSignatureMetadata(
//           signedDateIso,
//           signerMatchesPatient,
//         ),
//       };

//       await patchConsent(selectedConsent.currentConsentId, patchData);
//       setConsentActionSuccess("Consent signature metadata saved successfully.");
//       setTimeout(() => setConsentActionSuccess(""), 1000);
//       setReviewDialogOpen(false);
//       setSelectedConsent(null);
//       setParsedConsentMetadata(null);
//       setMismatchAcknowledged(false);
//       await loadPatientConsents(patient);
//     } catch (error) {
//       console.error("Error saving consent signature metadata:", error);
//       setConsentActionError(
//         error.message || "Failed to save consent signature metadata.",
//       );
//     } finally {
//       setSavingConsentMetadata(false);
//     }
//   };

//   const handleRevokeClick = (form) => {
//     setRevokeTarget(form);
//     setRevokeReason("");
//     setRevokeReasonError("");
//     setRevokeDialogOpen(true);
//   };

//   const handleCloseRevokeDialog = () => {
//     setRevokeDialogOpen(false);
//     setRevokeTarget(null);
//     setRevokeReason("");
//     setRevokeReasonError("");
//   };

//   const handleRevokeReasonChange = (event) => {
//     setRevokeReason(event.target.value);
//     if (event.target.value.trim()) {
//       setRevokeReasonError("");
//     }
//   };

//   const handleConfirmRevoke = async () => {
//     if (!revokeTarget) {
//       return;
//     }

//     if (!revokeReason.trim()) {
//       setRevokeReasonError("A reason is required to revoke this consent.");
//       return;
//     }

//     const consentIdToRevoke = revokeTarget.currentConsentId;
//     if (!consentIdToRevoke) {
//        setRevokeReasonError("Cannot revoke an unsigned consent.");
//        return;
//     }

//     try {
//       await revokeConsent(consentIdToRevoke, revokeReason);
//       setRevokeDialogOpen(false);
//       setRevokeTarget(null);
//       setRevokeReason("");
//       setRevokeReasonError("");
//       await loadPatientConsents(patient);
//     } catch (error) {
//       console.error("Error revoking consent:", error);
//       setRevokeReasonError(error.message || "Failed to revoke consent.");
//     }
//   };

//   const sampleHistoryColumns = [
//     {
//       field: "sampleBarcodeId",
//       headerName: "Barcode ID",
//       width: 140,
//     },
//     {
//       field: "sampleType",
//       headerName: "Sample Type",
//       flex: 1,
//       minWidth: 180,
//     },
//     {
//       field: "collectionDate",
//       headerName: "Collection Date",
//       width: 140,
//     },
//     {
//       field: "totalAliquotsCreated",
//       headerName: "Total Aliquots Created",
//       width: 180,
//     },
//   ];

//   const patientActivityColumns = [
//     {
//       field: "activity",
//       headerName: "Activity",
//       flex: 1,
//       minWidth: 280,
//     },
//     {
//       field: "date",
//       headerName: "Date",
//       width: 140,
//     },
//     {
//       field: "time",
//       headerName: "Time",
//       width: 120,
//     },
//   ];

//   const renderConsentEntry = (item, keyPrefix) => {
//     const consentKey = item.currentConsentId || item.consentName;
//     const isUploading = uploadingConsentId === consentKey;

//     // For styling/labels, item.status from backend (ACTIVE, NOT_SIGNED, EXPIRED, REVOKED)
//     let displayStatus = item.status === "ACTIVE" ? "Active" : item.status === "NOT_SIGNED" ? "Not Signed" : item.status === "REVOKED" ? "Revoked" : item.status === "DUPLICATE" ? "Duplicate" : item.status === "EXPIRED" ? "Expired" : item.status;
//     let bgColor = item.status === "ACTIVE" ? "#4CAF50" : item.status === "NOT_SIGNED" ? "#f57c00" : "#c62828";
//     if (item.status === "REVOKED" || item.status === "DUPLICATE") {
//       bgColor = "#9e9e9e";
//     }

//     return (
//       <Box key={keyPrefix || consentKey}>
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//             py: 1,
//           }}
//         >
//           <ChevronRightIcon sx={{ color: "#500000", fontSize: 20 }} />
//           <Typography variant="body1" sx={{ color: "#333", flex: 1 }}>
//             {item.irbStudy ? `${item.irbStudy}: ${item.consentName}` : item.consentName}
//           </Typography>
//           <Chip
//             label={displayStatus}
//             size="small"
//             sx={{
//               backgroundColor: bgColor,
//               color: "white",
//               fontWeight: 600,
//               fontSize: "0.75rem",
//             }}
//           />
//         </Box>

//         <Box
//           sx={{
//             mt: 1,
//             ml: 3,
//             p: 2,
//             border: "1px solid #eee",
//             borderRadius: 2,
//             backgroundColor: item.status === "REVOKED" ? "#f5f5f5" : "#fafafa",
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               gap: 2,
//               flexWrap: "wrap",
//             }}
//           >
//             <Stack spacing={0.75} sx={{ minWidth: 260 }}>
//               <Typography variant="body2" sx={{ color: item.status === "REVOKED" ? "#c62828" : "textSecondary", fontWeight: item.status === "REVOKED" ? 600 : 400 }}>
//                 {item.status === "REVOKED" ? "Status: Revoked" : `Consent Status: ${displayStatus}`}
//               </Typography>
//               {item.statusReason && (
//                 <Typography variant="body2" color="textSecondary">
//                   Reason: {item.statusReason}
//                 </Typography>
//               )}
//               {item.status === "ACTIVE" && item.activeRecord && (
//                 <>
//                   <Typography variant="body2" color="textSecondary">
//                     Signer: {item.activeRecord.extractedSignerName || "Not captured"}
//                   </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Signed Date:{" "}
//                         {formatDateTime(item.activeRecord.extractedSignedDate || item.activeRecord.consentDate)}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         Source: {item.activeRecord.signatureSourceType || "Not captured"}
//                       </Typography>
//                       {item.activeRecord.signatureMetadata && parseMetadataJson(item.activeRecord.signatureMetadata)?.protocolName && (
//                         <Typography variant="body2" color="textSecondary">
//                           Protocol: {parseMetadataJson(item.activeRecord.signatureMetadata).protocolName}
//                         </Typography>
//                       )}
//                       {item.activeRecord.expiresAt && (
//                         <Typography variant="body2" color="textSecondary">
//                           Expires: {formatDateTime(item.activeRecord.expiresAt)}
//                         </Typography>
//                       )}
//                     </>
//                   )}
//             </Stack>

//             <Stack direction="row" spacing={1} alignItems="flex-start">
//               {item.status === "ACTIVE" && (
//                 <>
//                   <Button
//                     component="label"
//                     variant="outlined"
//                     size="small"
//                     startIcon={isUploading ? <CircularProgress size={16} /> : <UploadFileIcon />}
//                     disabled={(!item.currentConsentId && item.consentType !== "GENERAL") || isUploading}
//                     sx={{
//                       textTransform: "none",
//                       color: "#500000",
//                       borderColor: "#500000",
//                       "&:hover": {
//                         backgroundColor: "#500000",
//                         color: "white",
//                         borderColor: "#500000",
//                       },
//                     }}
//                   >
//                     {isUploading ? "Parsing PDF..." : "Upload Signed PDF"}
//                     <input
//                       hidden
//                       type="file"
//                       accept="application/pdf,.pdf"
//                       onChange={(event) => handleConsentPdfSelected(item, event)}
//                     />
//                   </Button>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     onClick={() => handleRevokeClick(item)}
//                     disabled={!item.signed}
//                     sx={{
//                       textTransform: "none",
//                       color: "#c62828",
//                       borderColor: "#c62828",
//                       "&:hover": {
//                         backgroundColor: "#c62828",
//                         color: "white",
//                         borderColor: "#c62828",
//                       },
//                     }}
//                   >
//                     Revoke Consent
//                   </Button>
//                 </>
//               )}

//               {(item.status !== "ACTIVE") && (
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   onClick={() => handleOpenSignModal(item)}
//                   sx={{
//                     textTransform: "none",
//                     color: "#500000",
//                     borderColor: "#500000",
//                     "&:hover": {
//                       backgroundColor: "#500000",
//                       color: "white",
//                       borderColor: "#500000",
//                     },
//                   }}
//                 >
//                   Sign
//                 </Button>
//               )}
//             </Stack>
//           </Box>
//         </Box>
//       </Box>
//     );
//   };

//   const renderContactInformation = () => (
//     <Box>
//       {contactError && (
//         <Alert severity="error" sx={{ mb: 2 }} onClose={() => setContactError("")}>
//           {contactError}
//         </Alert>
//       )}
//       {contactSuccess && (
//         <Alert severity="success" sx={{ mb: 2 }} onClose={() => setContactSuccess("")}>
//           {contactSuccess}
//         </Alert>
//       )}

//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Typography variant="h6" sx={{ color: "#500000", fontWeight: 600 }}>
//           Contact Information
//         </Typography>
//         <Button
//           variant="outlined"
//           startIcon={<EditIcon />}
//           onClick={handleEditContact}
//           sx={{
//             color: "#500000",
//             borderColor: "#500000",
//             "&:hover": {
//               backgroundColor: "#500000",
//               color: "white",
//               borderColor: "#500000",
//             },
//           }}
//         >
//           Edit
//         </Button>
//       </Box>

//       {loadingContactInfo ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//           <CircularProgress sx={{ color: "#500000" }} />
//         </Box>
//       ) : (
//         <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 3 }}>
//           <Box>
//             <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//               Email Address
//             </Typography>
//             <Typography variant="body1">
//               {patient?.email || "—"}
//             </Typography>
//           </Box>
//           <Box>
//             <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//               Mobile Phone Number
//             </Typography>
//             <Typography variant="body1">
//               {patient?.mobilePhoneNumber || "—"}
//             </Typography>
//           </Box>
//           <Box sx={{ gridColumn: "span 2" }}>
//             <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//               Home Address
//             </Typography>
//             <Typography variant="body1">
//               {patient?.homeAddressLine1 ? (
//                 <>
//                   {patient.homeAddressLine1}
//                   {patient.homeAddressLine2 && `, ${patient.homeAddressLine2}`}
//                   <br />
//                   {patient.city && `${patient.city}, `}
//                   {patient.state && `${patient.state} `}
//                   {patient.zipCode}
//                 </>
//               ) : (
//                 "—"
//               )}
//             </Typography>
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );

//   const renderConsentFormsAndSurveys = () => (
//     <Box sx={{ display: "flex", gap: 4 }}>
//       {/* Sidebar Navigation */}
//       <Box sx={{ width: 240, flexShrink: 0 }}>
//         <List sx={{ p: 0 }}>
//           <ListItem
//             button
//             selected={subTabValue === 0}
//             onClick={() => setSubTabValue(0)}
//             sx={{
//               borderRadius: 1,
//               mb: 1,
//               backgroundColor: subTabValue === 0 ? "#500000" : "transparent",
//               color: subTabValue === 0 ? "white" : "inherit",
//               "&:hover": {
//                 backgroundColor: subTabValue === 0 ? "#500000" : "#f5f5f5",
//               },
//             }}
//           >
//             <ListItemText
//               primary="STUDY CONSENT"
//               sx={{
//                 textAlign: "center",
//                 "& .MuiListItemText-primary": {
//                   color: subTabValue === 0 ? "white" : "#666",
//                   fontWeight: 600,
//                 },
//               }}
//             />
//           </ListItem>
//           <ListItem
//             button
//             selected={subTabValue === 1}
//             onClick={() => setSubTabValue(1)}
//             sx={{
//               borderRadius: 1,
//               mb: 1,
//               backgroundColor: subTabValue === 1 ? "#500000" : "transparent",
//               color: subTabValue === 1 ? "white" : "inherit",
//               "&:hover": {
//                 backgroundColor: subTabValue === 1 ? "#500000" : "#f5f5f5",
//               },
//             }}
//           >
//             <ListItemText
//               primary="GENERAL CONSENT"
//               sx={{
//                 textAlign: "center",
//                 "& .MuiListItemText-primary": {
//                   color: subTabValue === 1 ? "white" : "#666",
//                   fontWeight: 600,
//                 },
//               }}
//             />
//           </ListItem>
//           <ListItem
//             button
//             selected={subTabValue === 2}
//             onClick={() => setSubTabValue(2)}
//             sx={{
//               borderRadius: 1,
//               backgroundColor: subTabValue === 2 ? "#500000" : "transparent",
//               color: subTabValue === 2 ? "white" : "inherit",
//               "&:hover": {
//                 backgroundColor: subTabValue === 2 ? "#500000" : "#f5f5f5",
//               },
//             }}
//           >
//             <ListItemText
//               primary="SURVEYS"
//               sx={{
//                 textAlign: "center",
//                 "& .MuiListItemText-primary": {
//                   color: subTabValue === 2 ? "white" : "#666",
//                   fontWeight: 600,
//                 },
//               }}
//             />
//           </ListItem>
//         </List>
//       </Box>

//       {/* Main Content */}
//       <Box sx={{ flex: 1 }}>
//         {subTabValue === 0 && (
//           <Box>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//               <Typography
//                 variant="h6"
//                 sx={{ fontWeight: 600, color: "#333" }}
//               >
//                 Study Consent:
//               </Typography>
//               <Button
//                 variant="contained"
//                 size="small"
//                 onClick={() => navigate(BIOBANK_SUB_ROUTES.PARTICIPANT_CHECKIN_WIZARD_CONSENT, { state: { patient, nextStep: location.pathname } })}
//                 sx={{
//                   textTransform: "none",
//                   backgroundColor: "#500000",
//                   color: "white",
//                   "&:hover": {
//                     backgroundColor: "#400000",
//                   },
//                 }}
//               >
//                 Sign All Consents
//               </Button>
//             </Box>
//             {consentActionError && (
//               <Alert
//                 severity="error"
//                 sx={{ mb: 2 }}
//                 onClose={() => setConsentActionError("")}
//               >
//                 {consentActionError}
//               </Alert>
//             )}
//             {consentActionSuccess && (
//               <Alert
//                 severity="success"
//                 sx={{ mb: 2 }}
//                 onClose={() => setConsentActionSuccess("")}
//               >
//                 {consentActionSuccess}
//               </Alert>
//             )}

//             {loadingConsents ? (
//               <Typography variant="body2" color="textSecondary">
//                 Loading study consents...
//               </Typography>
//             ) : (
//               <Stack spacing={4}>
//                 <Box>
//                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#333", mb: 1 }}>
//                     Active
//                   </Typography>
//                   {consentOverview.studyConsent.active.length > 0 ? (
//                     <Stack spacing={2} sx={{ mb: 3 }}>
//                       {consentOverview.studyConsent.active.map((item, idx) => renderConsentEntry(item, `study-active-${idx}`))}
//                     </Stack>
//                   ) : (
//                     <Typography variant="body2" color="textSecondary" sx={{ mb: 3, ml: 2 }}>
//                       No active study consents.
//                     </Typography>
//                   )}

//                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#333", mb: 1 }}>
//                     Inactive / Missing
//                   </Typography>
//                   {consentOverview.studyConsent.inactive.length > 0 ? (
//                     <Stack spacing={2} sx={{ mb: 3 }}>
//                       {consentOverview.studyConsent.inactive.map((item, idx) => renderConsentEntry(item, `study-inactive-${idx}`))}
//                     </Stack>
//                   ) : (
//                     <Typography variant="body2" color="textSecondary" sx={{ mb: 3, ml: 2 }}>
//                       No inactive study consents.
//                     </Typography>
//                   )}
//                 </Box>
//               </Stack>
//             )}
//           </Box>
//         )}

//         {subTabValue === 1 && (
//           <Box>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//               <Typography
//                 variant="h6"
//                 sx={{ fontWeight: 600, color: "#333" }}
//               >
//                 General Consent:
//               </Typography>
//               <Button
//                 variant="contained"
//                 size="small"
//                 onClick={() => navigate(BIOBANK_SUB_ROUTES.PARTICIPANT_CHECKIN_WIZARD_CONSENT, { state: { patient, nextStep: location.pathname } })}
//                 sx={{
//                   textTransform: "none",
//                   backgroundColor: "#500000",
//                   color: "white",
//                   "&:hover": {
//                     backgroundColor: "#400000",
//                   },
//                 }}
//               >
//                 Sign All Consents
//               </Button>
//             </Box>
//             {consentActionError && (
//               <Alert
//                 severity="error"
//                 sx={{ mb: 2 }}
//                 onClose={() => setConsentActionError("")}
//               >
//                 {consentActionError}
//               </Alert>
//             )}
//             {consentActionSuccess && (
//               <Alert
//                 severity="success"
//                 sx={{ mb: 2 }}
//                 onClose={() => setConsentActionSuccess("")}
//               >
//                 {consentActionSuccess}
//               </Alert>
//             )}

//             {loadingConsents ? (
//               <Typography variant="body2" color="textSecondary">
//                 Loading general consents...
//               </Typography>
//             ) : (
//               <Stack spacing={4}>
//                 <Box>
//                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#333", mb: 1 }}>
//                     Active
//                   </Typography>
//                   {consentOverview.generalConsent.active.length > 0 ? (
//                     <Stack spacing={2} sx={{ mb: 3 }}>
//                       {consentOverview.generalConsent.active.map((item, idx) => renderConsentEntry(item, `general-active-${idx}`))}
//                     </Stack>
//                   ) : (
//                     <Typography variant="body2" color="textSecondary" sx={{ mb: 3, ml: 2 }}>
//                       No active general consents.
//                     </Typography>
//                   )}

//                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#333", mb: 1 }}>
//                     Inactive / Missing
//                   </Typography>
//                   {consentOverview.generalConsent.inactive.length > 0 ? (
//                     <Stack spacing={2} sx={{ mb: 3 }}>
//                       {consentOverview.generalConsent.inactive.map((item, idx) => renderConsentEntry(item, `general-inactive-${idx}`))}
//                     </Stack>
//                   ) : (
//                     <Typography variant="body2" color="textSecondary" sx={{ mb: 3, ml: 2 }}>
//                       No inactive general consents.
//                     </Typography>
//                   )}
//                 </Box>
//               </Stack>
//             )}
//           </Box>
//         )}

//         {subTabValue === 2 && (
//           <Box>
//             <Typography
//               variant="h6"
//               sx={{ fontWeight: 600, mb: 2, color: "#333" }}
//             >
//               Patient Surveys:
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               No surveys available at this time.
//             </Typography>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );

//   const renderPatientActivity = () => {
//     const activityRows = patientActivity.map((item, index) => ({
//       id: index + 1,
//       activity: item.activity ?? "—",
//       date: item.date ?? "—",
//       time: item.time ?? "—",
//     }));
//     return (
//       <Box sx={{ height: 400, width: "100%" }}>
//         {loadingActivity ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: 200,
//             }}
//           >
//             <Typography color="textSecondary">Loading activity...</Typography>
//           </Box>
//         ) : activityRows.length === 0 ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: 200,
//             }}
//           >
//             <Typography color="textSecondary">
//               No activity data available.
//             </Typography>
//           </Box>
//         ) : (
//           <StyledDataGrid
//             rows={activityRows}
//             columns={patientActivityColumns}
//             pageSizeOptions={[10, 25, 50, 100]}
//             pagination
//             disableSelectionOnClick
//             initialState={{
//               pagination: {
//                 paginationModel: { pageSize: 25 },
//               },
//             }}
//           />
//         )}
//       </Box>
//     );
//   };

//   const renderSampleHistory = () => {
//     const historyRows = sampleHistory.map((item, index) => ({
//       id: index + 1,
//       sampleBarcodeId: item.sampleBarcodeId ?? "—",
//       sampleType: item.sampleType ?? "—",
//       collectionDate: item.collectionDate ?? "—",
//       totalAliquotsCreated: item.totalAliquotsCreated ?? 0,
//     }));
//     return (
//       <Box sx={{ height: 400, width: "100%" }}>
//         {loadingSampleHistory ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: 200,
//             }}
//           >
//             <Typography color="textSecondary">
//               Loading sample history...
//             </Typography>
//           </Box>
//         ) : historyRows.length === 0 ? (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: 200,
//             }}
//           >
//             <Typography color="textSecondary">
//               No sample history available.
//             </Typography>
//           </Box>
//         ) : (
//           <StyledDataGrid
//             rows={historyRows}
//             columns={sampleHistoryColumns}
//             pageSizeOptions={[10, 25, 50, 100]}
//             pagination
//             disableSelectionOnClick
//             initialState={{
//               pagination: {
//                 paginationModel: { pageSize: 25 },
//               },
//             }}
//           />
//         )}
//       </Box>
//     );
//   };

//   const renderConsentMetadataReviewDialog = () => {
//     const signerMatchesPatient = namesMatch(
//       reviewValues.signerName,
//       patient?.name,
//     );
//     const showNameMismatchWarning =
//       reviewValues.signerName && patient?.name && !signerMatchesPatient;
//     const requiresManualEntry = parsedConsentMetadata?.requiresManualEntry;
//     const sourceType = requiresManualEntry
//       ? "MANUAL_ENTRY"
//       : parsedConsentMetadata?.sourceType || "ADOBE_ESIGNED";
//     const additionalSigners = (parsedConsentMetadata?.signers || []).filter(
//       (signer) => signer.name !== reviewValues.signerName,
//     );

//     return (
//       <Dialog
//         open={reviewDialogOpen}
//         onClose={handleCloseReviewDialog}
//         fullWidth
//         maxWidth="md"
//       >
//         <DialogTitle sx={{ color: "#500000", fontWeight: 700 }}>
//           Review Consent Metadata
//         </DialogTitle>
//         <DialogContent dividers>
//           <Stack spacing={2}>
//             {requiresManualEntry ? (
//               <Alert severity="warning">
//                 This PDF was not recognized as an Adobe e-signed PDF. Please
//                 enter the consent metadata manually before saving.
//               </Alert>
//             ) : (
//               <Alert severity="success">
//                 Adobe e-signed PDF parsed successfully. Please review and
//                 confirm the extracted values.
//               </Alert>
//             )}

//             {consentActionError && (
//               <Alert severity="error" onClose={() => setConsentActionError("")}>
//                 {consentActionError}
//               </Alert>
//             )}

//             {showNameMismatchWarning && (
//               <Alert severity="error">
//                 <Typography variant="body2" sx={{ fontWeight: 700 }}>
//                   Strong warning: signer name does not match this participant.
//                 </Typography>
//                 <Typography variant="body2">
//                   Participant: {patient.name}
//                 </Typography>
//                 <Typography variant="body2">
//                   PDF/entered signer: {reviewValues.signerName}
//                 </Typography>
//               </Alert>
//             )}

//             <Box
//               sx={{
//                 display: "grid",
//                 gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
//                 gap: 2,
//               }}
//             >
//               <TextField
//                 label="Subject Signer Name"
//                 value={reviewValues.signerName}
//                 onChange={handleReviewValueChange("signerName")}
//                 required
//                 fullWidth
//               />
//               <TextField
//                 label="Signed Date"
//                 type="datetime-local"
//                 value={reviewValues.signedDate}
//                 onChange={handleReviewValueChange("signedDate")}
//                 required
//                 fullWidth
//                 InputLabelProps={{ shrink: true }}
//               />
//               <TextField
//                 label="IRB Study"
//                 value={reviewValues.irbStudy}
//                 onChange={handleReviewValueChange("irbStudy")}
//                 required
//                 fullWidth
//               />
//               <TextField
//                 label="Protocol Name"
//                 value={reviewValues.protocolName}
//                 onChange={handleReviewValueChange("protocolName")}
//                 fullWidth
//               />
//             </Box>

//             <Box
//               sx={{
//                 p: 2,
//                 border: "1px solid #eee",
//                 borderRadius: 2,
//                 backgroundColor: "#fafafa",
//               }}
//             >
//               <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
//                 Parse Details
//               </Typography>
//               <Stack
//                 direction="row"
//                 spacing={1}
//                 sx={{ flexWrap: "wrap", gap: 1 }}
//               >
//                 <Chip
//                   label={`Source: ${sourceType}`}
//                   size="small"
//                   sx={{ ...BASE_CHIP_SX, ...STATUS_CHIP_STYLES.default }}
//                 />
//                 <Chip
//                   label={`Confidence: ${parsedConsentMetadata?.confidence || "Manual"}`}
//                   size="small"
//                   sx={{
//                     ...BASE_CHIP_SX,
//                     ...(parsedConsentMetadata?.confidence === "HIGH"
//                       ? STATUS_CHIP_STYLES.success
//                       : STATUS_CHIP_STYLES.warning),
//                   }}
//                 />
//                 <Chip
//                   label={`Manual Entry: ${requiresManualEntry ? "Yes" : "No"}`}
//                   size="small"
//                   sx={{
//                     ...BASE_CHIP_SX,
//                     ...(requiresManualEntry
//                       ? STATUS_CHIP_STYLES.warning
//                       : STATUS_CHIP_STYLES.success),
//                   }}
//                 />
//               </Stack>

//               {additionalSigners.length > 0 && (
//                 <Box sx={{ mt: 2 }}>
//                   <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
//                     Additional Signers
//                   </Typography>
//                   {additionalSigners.map((signer, index) => (
//                     <Typography
//                       key={`${signer.name}-${index}`}
//                       variant="body2"
//                       color="textSecondary"
//                     >
//                       {signer.name} · {signer.role || "unknown role"} ·{" "}
//                       {formatDateTime(signer.signedAt)}
//                     </Typography>
//                   ))}
//                 </Box>
//               )}

//               {parsedConsentMetadata?.warnings?.length > 0 && (
//                 <Box sx={{ mt: 2 }}>
//                   <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
//                     Warnings
//                   </Typography>
//                   {parsedConsentMetadata.warnings.map((warning, index) => (
//                     <Typography key={index} variant="body2" color="error">
//                       {warning}
//                     </Typography>
//                   ))}
//                 </Box>
//               )}
//             </Box>

//             {showNameMismatchWarning && (
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={mismatchAcknowledged}
//                     onChange={(event) =>
//                       setMismatchAcknowledged(event.target.checked)
//                     }
//                   />
//                 }
//                 label="I understand the signer name does not match the participant and still want to save this consent metadata."
//               />
//             )}
//           </Stack>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={handleCloseReviewDialog}
//             disabled={savingConsentMetadata}
//             sx={{ textTransform: "none", color: "#500000" }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleConfirmConsentMetadata}
//             disabled={
//               savingConsentMetadata ||
//               !reviewValues.signerName ||
//               !reviewValues.signedDate ||
//               !reviewValues.irbStudy ||
//               (showNameMismatchWarning && !mismatchAcknowledged)
//             }
//             sx={{
//               textTransform: "none",
//               backgroundColor: "#500000",
//               "&:hover": { backgroundColor: "#400000" },
//             }}
//           >
//             {savingConsentMetadata ? (
//               <>
//                 <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
//                 Saving...
//               </>
//             ) : (
//               "Confirm & Save"
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };

//   const renderRevokeConsentDialog = () => {
//     const todayFormatted = new Date().toLocaleDateString("en-US", {
//       month: "2-digit",
//       day: "2-digit",
//       year: "numeric",
//     });

//     return (
//       <Dialog
//         open={revokeDialogOpen}
//         onClose={handleCloseRevokeDialog}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle sx={{ color: "#500000", fontWeight: 700 }}>
//           Revoke Consent?
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" sx={{ mb: 1.5 }}>
//             You are about to revoke{" "}
//             {revokeTarget?.name ? `"${revokeTarget.name}"` : "this"} consent
//             effective today ({todayFormatted}).
//           </Typography>
//           <Typography variant="body2" sx={{ mb: 1.5 }}>
//             This action will revoke this consent permanently. A new consent must be signed to participate again.
//           </Typography>
//           <TextField
//             label="Reason for revocation"
//             placeholder="Enter the reason this consent is being revoked"
//             value={revokeReason}
//             onChange={handleRevokeReasonChange}
//             required
//             fullWidth
//             multiline
//             minRows={2}
//             error={Boolean(revokeReasonError)}
//             helperText={
//               revokeReasonError ||
//               "This reason will be saved as part of the revocation record."
//             }
//             sx={{ mb: 1.5 }}
//           />
//           <Typography variant="body2" sx={{ fontWeight: 600 }}>
//             Are you sure you want to continue?
//           </Typography>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={handleCloseRevokeDialog}
//             sx={{ textTransform: "none", color: "#500000" }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleConfirmRevoke}
//             disabled={!revokeReason.trim()}
//             sx={{
//               textTransform: "none",
//               backgroundColor: "#c62828",
//               "&:hover": { backgroundColor: "#8e0000" },
//             }}
//           >
//             Revoke
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };

//   const renderEditContactDialog = () => (
//     <Dialog open={editingContact} onClose={handleCancelContactEdit} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ color: "#500000", fontWeight: 700 }}>Edit Contact Information</DialogTitle>
//       <DialogContent>
//         {contactError && (
//           <Alert severity="error" sx={{ mb: 2 }}>{contactError}</Alert>
//         )}
//         <Stack spacing={2} sx={{ mt: 1 }}>
//           <TextField
//             label="Email"
//             fullWidth
//             value={contactInfo.email}
//             onChange={handleContactFieldChange("email")}
//             type="email"
//           />
//           <TextField
//             label="Mobile Phone"
//             fullWidth
//             value={contactInfo.mobilePhoneNumber}
//             onChange={handleContactFieldChange("mobilePhoneNumber")}
//           />
//           <TextField
//             label="Address Line 1"
//             fullWidth
//             value={contactInfo.homeAddressLine1}
//             onChange={handleContactFieldChange("homeAddressLine1")}
//           />
//           <TextField
//             label="Address Line 2"
//             fullWidth
//             value={contactInfo.homeAddressLine2}
//             onChange={handleContactFieldChange("homeAddressLine2")}
//           />
//           <Box sx={{ display: "flex", gap: 2 }}>
//             <TextField
//               label="City"
//               fullWidth
//               value={contactInfo.city}
//               onChange={handleContactFieldChange("city")}
//             />
//             <TextField
//               select
//               label="State"
//               fullWidth
//               value={contactInfo.state}
//               onChange={handleContactFieldChange("state")}
//             >
//               <MenuItem value=""><em>None</em></MenuItem>
//               {US_STATES.map((state) => (
//                 <MenuItem key={state.value} value={state.value}>
//                   {state.label}
//                 </MenuItem>
//               ))}
//             </TextField>
//             <TextField
//               label="Zip Code"
//               fullWidth
//               value={contactInfo.zipCode}
//               onChange={handleContactFieldChange("zipCode")}
//             />
//           </Box>
//         </Stack>
//       </DialogContent>
//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={handleCancelContactEdit} sx={{ textTransform: "none", color: "#500000" }}>
//           Cancel
//         </Button>
//         <Button
//           variant="contained"
//           onClick={handleSaveContactInfo}
//           disabled={savingContact}
//           sx={{ textTransform: "none", backgroundColor: "#500000", "&:hover": { backgroundColor: "#400000" } }}
//         >
//           {savingContact ? "Saving..." : "Save Changes"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );

//   if (!patient) {
//     return <Box>Loading...</Box>;
//   }

//   return (
//     <RecordProfilePage
//       title="Participant Profile"
//       backTo="/admin/patient-data"
//       maxWidth={1200}
//     >
//       {/* Participant Information Card */}
//       <Card
//         sx={{
//           mb: 3,
//           borderRadius: 2,
//           boxShadow: "none",
//           border: "1px solid #e0e0e0",
//         }}
//       >
//         <CardContent sx={{ p: 3 }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
//             <Avatar
//               sx={{
//                 width: 80,
//                 height: 80,
//                 backgroundColor: "#500000",
//                 fontSize: "2rem",
//                 fontWeight: 600,
//                 color: "white",
//               }}
//             >
//               {patient.initials}
//             </Avatar>
//             <Box sx={{ flex: 1 }}>
//               <Typography
//                 variant="h4"
//                 sx={{
//                   fontWeight: 700,
//                   mb: 2,
//                   color: "#500000",
//                   fontSize: "2rem",
//                 }}
//               >
//                 {patient.name}
//               </Typography>
//               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
//                 <Box>
//                   <Typography
//                     variant="body2"
//                     sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
//                   >
//                     Active Since:
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: "#666" }}>
//                     {patient.activeSince}
//                   </Typography>
//                 </Box>
//                 <Box>
//                   <Typography
//                     variant="body2"
//                     sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
//                   >
//                     Date of Birth:
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: "#666" }}>
//                     {formatDateOnly(patient.dateOfBirth)}
//                   </Typography>
//                 </Box>
//                 <Box sx={{ minWidth: "200px" }}>
//                   <Typography
//                     variant="body2"
//                     sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
//                   >
//                     Participation:
//                   </Typography>
//                   <Stack spacing={0.5}>
//                     {patient.irbStudies.map((study) => (
//                       <Typography
//                         key={study.id}
//                         variant="body2"
//                         sx={{ color: "#666" }}
//                       >
//                         {study.id}
//                         {study.status
//                           ? `: ${study.status}`
//                           : study.name !== study.id
//                             ? `: ${study.name}`
//                             : ""}
//                       </Typography>
//                     ))}
//                   </Stack>
//                 </Box>
//                 <Box>
//                   <Typography
//                     variant="body2"
//                     sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
//                   >
//                     Date of Last Visit:
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: "#666" }}>
//                     {formatDateOnly(patient.lastVisit)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Tab Content Card */}
//       <Card
//         sx={{
//           borderRadius: 2,
//           boxShadow: "none",
//           border: "1px solid #e0e0e0",
//           minHeight: 400,
//         }}
//       >
//         {/* Navigation Tabs */}
//         <Box sx={{ p: 3, pb: 0 }}>
//           <Tabs
//             value={tabValue}
//             onChange={handleTabChange}
//             sx={{
//               "& .MuiTab-root": {
//                 textTransform: "none",
//                 fontWeight: 600,
//                 fontSize: "0.875rem",
//                 px: 2,
//                 py: 1,
//                 borderRadius: "20px",
//                 marginRight: 3,
//                 minHeight: "auto",
//                 backgroundColor: "transparent",
//                 color: "#500000",
//                 border: "1px solid #500000",
//                 "&:hover": {
//                   backgroundColor: "#f0f0f0",
//                 },
//               },
//               "& .Mui-selected": {
//                 backgroundColor: "#500000 !important",
//                 color: "white !important",
//                 "&:hover": {
//                   backgroundColor: "#400000 !important",
//                 },
//               },
//               "& .MuiTabs-indicator": {
//                 display: "none",
//               },
//             }}
//           >
//             <Tab label="CONTACT INFORMATION" />
//             <Tab label="CONSENT FORMS & SURVEYS" />
//             <Tab label="PARTICIPANT ACTIVITY" />
//             <Tab label="SAMPLE HISTORY" />
//           </Tabs>
//           <Divider sx={{ mt: 2 }} />
//         </Box>

//         <CardContent sx={{ p: 3, pt: 2 }}>
//           {tabValue === 0 && renderContactInformation()}
//           {tabValue === 1 && renderConsentFormsAndSurveys()}
//           {tabValue === 2 && renderPatientActivity()}
//           {tabValue === 3 && renderSampleHistory()}
//         </CardContent>
//       </Card>
//       {renderConsentMetadataReviewDialog()}
//       {renderRevokeConsentDialog()}
//       {renderEditContactDialog()}

//       <Dialog
//         open={confirmSignModalOpen}
//         onClose={() => !isSigningConsent && setConfirmSignModalOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ color: "#500000", fontWeight: 600 }}>
//           Confirm Consents Selection
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body1">
//             Clicking Confirm & Continue indicates you have received the participant's signed paper consent form(s) for the following:
//           </Typography>
//           <Box sx={{ mt: 2, pl: 2 }}>
//             <ul style={{ margin: 0 }}>
//               <li>
//                 <Typography variant="body2" sx={{ fontWeight: 600, color: "#3E3E3E" }}>
//                   {consentToSign?.consentName || consentToSign?.id}
//                   {consentToSign?.irbStudy ? ` (${consentToSign.irbStudy})` : ""}
//                 </Typography>
//               </li>
//             </ul>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, pt: 0 }}>
//           <Button
//             onClick={() => setConfirmSignModalOpen(false)}
//             variant="outlined"
//             disabled={isSigningConsent}
//             sx={{ borderColor: "#500000", color: "#500000" }}
//           >
//             Go Back
//           </Button>
//           <Button
//             onClick={handleConfirmSign}
//             variant="contained"
//             disabled={isSigningConsent}
//             sx={{ backgroundColor: "#500000", "&:hover": { backgroundColor: "#3a0000" } }}
//           >
//             {isSigningConsent ? "Saving..." : "Yes, Continue"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </RecordProfilePage>
//   );
// };

// export default PatientProfile;
import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  Avatar,
  Tabs,
  Tab,
  Card,
  CardContent,
  Chip,
  Stack,
  Divider,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Alert,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
} from "@mui/material";
import {
  ChevronRight as ChevronRightIcon,
  UploadFile as UploadFileIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import StyledDataGrid from "../../components/StyledDataGrid";
import RecordProfilePage from "../../components/RecordProfilePage";
import {
  BASE_CHIP_SX,
  STATUS_CHIP_STYLES,
  getStatusChipStyle,
} from "../../constants/statusColors";
import { US_STATES, ALZHEIMERS_STATUS_OPTIONS } from "../../constants/patientOptions";
import { BIOBANK_SUB_ROUTES } from "../../constants/routes";
import {
  fetchConsentOverview,
  fetchStudies,
  fetchPatientActivity,
  fetchPatientSampleHistory,
  parseConsentPdfMetadata,
  patchConsent,
  revokeConsent,
  updatePatient,
  fetchPatientById,
} from "../../utils/api";
import { submitConsents } from "../../utils/apiConsent";
import {
  chicagoDateTimeLocalToIso,
  formatDateTimeInAppTimeZone,
  formatDateInAppTimeZone,
  isoToChicagoDateTimeLocal,
  nowIso,
} from "../../utils/appDateTime";
import GenomicReportsTab from "./GenomicReportsTab";

const ALZHEIMERS_STATUS_LABELS = ALZHEIMERS_STATUS_OPTIONS.reduce(
  (acc, opt) => ({ ...acc, [opt.value]: opt.label }),
  {},
);


const GENDER_OPTIONS = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
  { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
];

const parseMetadataJson = (metadataJson) => {
  if (!metadataJson) {
    return {};
  }
  try {
    return JSON.parse(metadataJson);
  } catch (error) {
    console.warn("Unable to parse consent signature metadata JSON:", error);
    return {};
  }
};

const formatDateTime = (value) => {
  if (!value) {
    return "Not captured";
  }
  return formatDateTimeInAppTimeZone(value, value);
};

const formatDateOnly = (value) => {
  if (!value) {
    return "N/A";
  }
  if (typeof value === "string") {
    const isoDateMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (isoDateMatch) {
      return isoDateMatch[1];
    }
  }
  return formatDateInAppTimeZone(value, value);
};

const formatActiveSince = (value) => {
  if (!value) {
    return "N/A";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "N/A";
  }
  return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
};

const toDateTimeLocalValue = (value) => {
  if (!value) {
    return "";
  }
  return isoToChicagoDateTimeLocal(value);
};

const normalizePersonName = (value) =>
  (value || "")
    .toLowerCase()
    .replace(/[^a-z\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const namesMatch = (left, right) => {
  const normalizedLeft = normalizePersonName(left);
  const normalizedRight = normalizePersonName(right);
  return Boolean(
    normalizedLeft && normalizedRight && normalizedLeft === normalizedRight,
  );
};

const getConsentKey = (item) => item?.currentConsentId || item?.consentName;

const emptyContactInfo = {
  email: "",
  mobilePhoneNumber: "",
  homeAddressLine1: "",
  homeAddressLine2: "",
  city: "",
  state: "",
  zipCode: "",
};

const PatientProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tabValue, setTabValue] = useState(0);
  const [patient, setPatient] = useState(null);
  const [subTabValue, setSubTabValue] = useState(0);
  const [consentOverview, setConsentOverview] = useState({
    studyConsent: { active: [], inactive: [] },
    generalConsent: { active: [], inactive: [] },
    survey: [],
  });
  const [loadingConsents, setLoadingConsents] = useState(false);
  const [patientActivity, setPatientActivity] = useState([]);
  const [loadingActivity, setLoadingActivity] = useState(false);
  const [sampleHistory, setSampleHistory] = useState([]);
  const [loadingSampleHistory, setLoadingSampleHistory] = useState(false);
  const [uploadingConsentId, setUploadingConsentId] = useState(null);
  const [reviewDialogOpen, setReviewDialogOpen] = useState(false);
  const [selectedConsent, setSelectedConsent] = useState(null);
  const [parsedConsentMetadata, setParsedConsentMetadata] = useState(null);
  const [reviewValues, setReviewValues] = useState({
    signerName: "",
    signedDate: "",
    irbStudy: "",
    protocolName: "",
  });
  const [mismatchAcknowledged, setMismatchAcknowledged] = useState(false);
  const [savingConsentMetadata, setSavingConsentMetadata] = useState(false);
  const [consentActionError, setConsentActionError] = useState("");
  const [consentActionSuccess, setConsentActionSuccess] = useState("");
  const [revokeDialogOpen, setRevokeDialogOpen] = useState(false);
  const [revokeTarget, setRevokeTarget] = useState(null);
  const [revokeReason, setRevokeReason] = useState("");
  const [revokeReasonError, setRevokeReasonError] = useState("");

  const [contactInfo, setContactInfo] = useState(emptyContactInfo);
  const [editingContact, setEditingContact] = useState(false);
  const [savingContact, setSavingContact] = useState(false);
  const [contactError, setContactError] = useState("");
  const [contactSuccess, setContactSuccess] = useState("");
  const [loadingContactInfo, setLoadingContactInfo] = useState(false);

  const [confirmSignModalOpen, setConfirmSignModalOpen] = useState(false);
  const [consentToSign, setConsentToSign] = useState(null);
  const [isSigningConsent, setIsSigningConsent] = useState(false);

  const handleOpenSignModal = (item) => {
    setConsentToSign(item);
    setConfirmSignModalOpen(true);
  };

  const handleConfirmSign = async () => {
    if (!consentToSign) return;
    try {
      setIsSigningConsent(true);

      const formId =
        consentToSign.availableForms?.[0]?.consentFormId || consentToSign.id;
      if (!formId) throw new Error("Consent form ID is missing.");

      const consentsToSubmit = [
        {
          consentFormId: formId,
          consentDate: new Date().toISOString(),
        },
      ];

      await submitConsents(patient?.id || patient?.patientId, consentsToSubmit);

      setConsentActionSuccess(`Successfully signed consent form.`);
      setTimeout(() => setConsentActionSuccess(""), 1000);
      setConfirmSignModalOpen(false);
      setConsentToSign(null);
      // Reload profile data
      loadPatientConsents(patient);
    } catch (err) {
      console.error("Error signing consent:", err);
      setConsentActionError(
        err.message || "Failed to sign consent. Please try again.",
      );
    } finally {
      setIsSigningConsent(false);
    }
  };

  const loadPatientConsents = useCallback(async (patientData) => {
    if (!patientData?.id) {
      setConsentOverview({
        studyConsent: { active: [], inactive: [] },
        generalConsent: { active: [], inactive: [] },
        survey: [],
      });
      return;
    }
    try {
      setLoadingConsents(true);
      const overview = await fetchConsentOverview(patientData.id);
      if (overview) {
        setConsentOverview(overview);
      }
    } catch (error) {
      console.error("❌ Error loading consent overview:", error);
    } finally {
      setLoadingConsents(false);
    }
  }, []);

  useEffect(() => {
    const loadData = async () => {
      let transformedPatient;
      let patientId = null;

      if (location.state?.patient) {
        const patientData = location.state.patient;
        patientId = patientData.id;
        transformedPatient = {
          id: patientData.id,
          patientAccountNumber: patientData.patientAccountNumber || "",
          name: patientData.name,
          initials: patientData.name
            ? patientData.name
                .split(" ")
                .map((n) => n[0])
                .join("")
            : "XX",
          dateOfBirth: patientData.dateOfBirth,
          activeSince: formatActiveSince(patientData.consentDate),
          irbStudies: Array.isArray(patientData.irbStudies)
            ? patientData.irbStudies.map((study) => {
                const normalizedStudy =
                  typeof study === "string"
                    ? { irbStudy: study, status: null }
                    : study;
                return {
                  id: normalizedStudy.irbStudy,
                  name: normalizedStudy.irbStudy,
                  status: normalizedStudy.status || null,
                };
              })
            : [],
          lastVisit:
            patientData.lastVisit !== "N/A" ? patientData.lastVisit : null,
          email: patientData.email || "",
          mobilePhoneNumber: patientData.mobilePhoneNumber || "",
          gender: (patientData.gender || "").toUpperCase(),
          alzheimersStatus: patientData.alzheimersStatus || "",
          homeAddressLine1: patientData.homeAddressLine1 || "",
          homeAddressLine2: patientData.homeAddressLine2 || "",
          city: patientData.city || "",
          state: patientData.state || "",
          zipCode: patientData.zipCode || "",
        };
      } else {
        console.warn("PatientProfile: no patient data in navigation state — redirecting.");
        navigate("/admin/patient-data");
        return;
      }

      setPatient(transformedPatient);
      await loadPatientConsents(transformedPatient);

      if (patientId) {
        try {
          setLoadingContactInfo(true);
          const fullPatient = await fetchPatientById(patientId);
          if (fullPatient) {
            setPatient((prev) => ({
              ...prev,
              dateOfBirth: fullPatient.birthDate || prev.dateOfBirth,
              activeSince: fullPatient.consentDate
                ? formatActiveSince(fullPatient.consentDate)
                : prev.activeSince,
              email: fullPatient.email || prev.email || "",
              mobilePhoneNumber:
                fullPatient.mobilePhoneNumber || prev.mobilePhoneNumber || "",
              gender: (fullPatient.gender || prev.gender || "").toUpperCase(),
              alzheimersStatus:
                fullPatient.alzheimersStatus || prev.alzheimersStatus || "",
              homeAddressLine1:
                fullPatient.homeAddressLine1 || prev.homeAddressLine1 || "",
              homeAddressLine2:
                fullPatient.homeAddressLine2 || prev.homeAddressLine2 || "",
              city: fullPatient.city || prev.city || "",
              state: fullPatient.state || prev.state || "",
              zipCode: fullPatient.zipCode || prev.zipCode || "",
            }));
          }
        } catch (error) {
          console.error("Error loading full patient record:", error);
        } finally {
          setLoadingContactInfo(false);
        }
      }
    };

    loadData();
  }, [location.state, loadPatientConsents, navigate]);

  useEffect(() => {
    if (patient) {
      setContactInfo({
        email: patient.email || "",
        mobilePhoneNumber: patient.mobilePhoneNumber || "",
        homeAddressLine1: patient.homeAddressLine1 || "",
        homeAddressLine2: patient.homeAddressLine2 || "",
        city: patient.city || "",
        state: patient.state || "",
        zipCode: patient.zipCode || "",
      });
    }
  }, [patient]);

  useEffect(() => {
    const allActive = [
      ...consentOverview.studyConsent.active,
      ...consentOverview.generalConsent.active,
    ];

    if (allActive.length === 0) {
      return;
    }
    const signedDates = allActive
      .filter((item) => item.signed && item.activeRecord?.consentDate)
      .map((item) => new Date(item.activeRecord.consentDate))
      .filter((date) => !Number.isNaN(date.getTime()));

    if (signedDates.length === 0) {
      return;
    }

    const earliestSignDate = new Date(
      Math.min(...signedDates.map((date) => date.getTime())),
    );

    setPatient((prev) =>
      prev
        ? {
            ...prev,
            activeSince: formatActiveSince(earliestSignDate.toISOString()),
          }
        : prev,
    );
  }, [consentOverview]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (
      newValue === 2 &&
      patient?.id &&
      patientActivity.length === 0 &&
      !loadingActivity
    ) {
      loadPatientActivity(patient.id);
    }
    if (
      newValue === 3 &&
      patient?.id &&
      sampleHistory.length === 0 &&
      !loadingSampleHistory
    ) {
      loadSampleHistory(patient.id);
    }
  };

  const loadPatientActivity = useCallback(async (patientId) => {
    if (!patientId) return;
    try {
      setLoadingActivity(true);
      const data = await fetchPatientActivity(patientId);
      setPatientActivity(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error loading patient activity:", error);
      setPatientActivity([]);
    } finally {
      setLoadingActivity(false);
    }
  }, []);

  const loadSampleHistory = useCallback(async (patientId) => {
    if (!patientId) return;
    try {
      setLoadingSampleHistory(true);
      const data = await fetchPatientSampleHistory(patientId);
      setSampleHistory(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error loading sample history:", error);
      setSampleHistory([]);
    } finally {
      setLoadingSampleHistory(false);
    }
  }, []);

  const handleSubTabChange = (newValue) => {
    setSubTabValue(newValue);
  };

  const handleContactFieldChange = (field) => (event) => {
    setContactInfo((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleEditContact = () => {
    setContactError("");
    setContactSuccess("");
    setEditingContact(true);
  };

  const handleCancelContactEdit = () => {
    setContactInfo({
      email: patient?.email || "",
      mobilePhoneNumber: patient?.mobilePhoneNumber || "",
      homeAddressLine1: patient?.homeAddressLine1 || "",
      homeAddressLine2: patient?.homeAddressLine2 || "",
      city: patient?.city || "",
      state: patient?.state || "",
      zipCode: patient?.zipCode || "",
    });
    setContactError("");
    setEditingContact(false);
  };

  const handleSaveContactInfo = async () => {
    if (!patient?.id) {
      setContactError("Unable to save contact information for this patient.");
      return;
    }

    try {
      setSavingContact(true);
      setContactError("");
      setContactSuccess("");

      await updatePatient(patient.id, contactInfo);

      setPatient((prev) => ({ ...prev, ...contactInfo }));
      setContactSuccess("Contact information updated successfully.");
      setEditingContact(false);
    } catch (error) {
      console.error("Error updating contact information:", error);
      setContactError(error.message || "Failed to update contact information.");
    } finally {
      setSavingContact(false);
    }
  };

  const handleConsentPdfSelected = async (item, event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) {
      return;
    }

    if (!item?.currentConsentId && item.consentType !== "GENERAL") {
      setConsentActionError(
        "A consent record is required before uploading signed PDF metadata.",
      );
      return;
    }

    try {
      setConsentActionError("");
      setConsentActionSuccess("");
      setUploadingConsentId(getConsentKey(item));

      const metadata = await parseConsentPdfMetadata(file);

      const recommendedPatch = metadata?.recommendedConsentPatch || {};
      setSelectedConsent(item);
      setParsedConsentMetadata(metadata);
      setReviewValues({
        signerName:
          recommendedPatch.extractedSignerName ||
          metadata?.primarySignerName ||
          "",
        signedDate: toDateTimeLocalValue(
          recommendedPatch.extractedSignedDate ||
            metadata?.signedDate ||
            item.activeRecord?.extractedSignedDate ||
            item.activeRecord?.consentDate,
        ),
        irbStudy: metadata?.irbStudy || item.irbStudy || "",
        protocolName:
          metadata?.protocolName ||
          (item.activeRecord?.signatureMetadata &&
            parseMetadataJson(item.activeRecord.signatureMetadata)
              ?.protocolName) ||
          "",
      });
      setMismatchAcknowledged(false);
      setReviewDialogOpen(true);
    } catch (error) {
      console.error("Error parsing consent PDF metadata:", error);
      setConsentActionError(
        error.message || "Failed to parse consent PDF metadata.",
      );
    } finally {
      setUploadingConsentId(null);
    }
  };

  const handleReviewValueChange = (field) => (event) => {
    setReviewValues((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
    if (field === "signerName") {
      setMismatchAcknowledged(false);
    }
  };

  const handleCloseReviewDialog = () => {
    if (savingConsentMetadata) {
      return;
    }
    setReviewDialogOpen(false);
    setSelectedConsent(null);
    setParsedConsentMetadata(null);
    setMismatchAcknowledged(false);
  };

  const buildConfirmedSignatureMetadata = (
    signedDateIso,
    signerMatchesPatient,
  ) => {
    const baseMetadata = parseMetadataJson(parsedConsentMetadata?.metadataJson);
    const confirmedMetadata = {
      ...baseMetadata,
      primarySignerName: reviewValues.signerName || null,
      signedDate: signedDateIso,
      irbStudy: reviewValues.irbStudy || null,
      protocolName: reviewValues.protocolName || null,
      userConfirmed: true,
      userConfirmedAt: nowIso(),
      signerMatchesPatient,
      mismatchAcknowledged,
    };

    if (!confirmedMetadata.source) {
      confirmedMetadata.source = "patient-profile-upload";
    }
    if (!confirmedMetadata.sourceType) {
      confirmedMetadata.sourceType =
        parsedConsentMetadata?.sourceType ||
        selectedConsent?.activeRecord?.signatureSourceType ||
        "MANUAL_ENTRY";
    }
    if (!Array.isArray(confirmedMetadata.signers)) {
      confirmedMetadata.signers = [];
    }

    return JSON.stringify(confirmedMetadata);
  };

  const handleConfirmConsentMetadata = async () => {
    if (
      !selectedConsent?.currentConsentId &&
      selectedConsent?.consentType !== "GENERAL"
    ) {
      setConsentActionError(
        "Unable to save metadata because no consent record is selected.",
      );
      return;
    }

    const signerMatchesPatient = namesMatch(
      reviewValues.signerName,
      patient?.name,
    );
    if (!signerMatchesPatient && !mismatchAcknowledged) {
      setConsentActionError(
        "Signer name does not match the participant. Please acknowledge the mismatch before saving.",
      );
      return;
    }

    if (
      !reviewValues.signerName ||
      !reviewValues.signedDate ||
      !reviewValues.irbStudy
    ) {
      setConsentActionError(
        "Signer name, signed date, and IRB study are required.",
      );
      return;
    }

    try {
      setSavingConsentMetadata(true);
      setConsentActionError("");
      setConsentActionSuccess("");

      const signedDateIso = chicagoDateTimeLocalToIso(reviewValues.signedDate);
      if (!signedDateIso) {
        setConsentActionError("Signed date is invalid.");
        return;
      }

      const signatureSourceType = parsedConsentMetadata?.requiresManualEntry
        ? "MANUAL_ENTRY"
        : parsedConsentMetadata?.sourceType || "ADOBE_ESIGNED";

      const patchData = {
        signatureSourceType,
        extractedSignerName: reviewValues.signerName,
        extractedSignedDate: signedDateIso,
        consentDate: signedDateIso,
        signatureMetadata: buildConfirmedSignatureMetadata(
          signedDateIso,
          signerMatchesPatient,
        ),
      };

      await patchConsent(selectedConsent.currentConsentId, patchData);
      setConsentActionSuccess("Consent signature metadata saved successfully.");
      setTimeout(() => setConsentActionSuccess(""), 1000);
      setReviewDialogOpen(false);
      setSelectedConsent(null);
      setParsedConsentMetadata(null);
      setMismatchAcknowledged(false);
      await loadPatientConsents(patient);
    } catch (error) {
      console.error("Error saving consent signature metadata:", error);
      setConsentActionError(
        error.message || "Failed to save consent signature metadata.",
      );
    } finally {
      setSavingConsentMetadata(false);
    }
  };

  const handleRevokeClick = (form) => {
    setRevokeTarget(form);
    setRevokeReason("");
    setRevokeReasonError("");
    setRevokeDialogOpen(true);
  };

  const handleCloseRevokeDialog = () => {
    setRevokeDialogOpen(false);
    setRevokeTarget(null);
    setRevokeReason("");
    setRevokeReasonError("");
  };

  const handleRevokeReasonChange = (event) => {
    setRevokeReason(event.target.value);
    if (event.target.value.trim()) {
      setRevokeReasonError("");
    }
  };

  const handleConfirmRevoke = async () => {
    if (!revokeTarget) {
      return;
    }

    if (!revokeReason.trim()) {
      setRevokeReasonError("A reason is required to revoke this consent.");
      return;
    }

    const consentIdToRevoke = revokeTarget.currentConsentId;
    if (!consentIdToRevoke) {
      setRevokeReasonError("Cannot revoke an unsigned consent.");
      return;
    }

    try {
      await revokeConsent(consentIdToRevoke, revokeReason);
      setRevokeDialogOpen(false);
      setRevokeTarget(null);
      setRevokeReason("");
      setRevokeReasonError("");
      await loadPatientConsents(patient);
    } catch (error) {
      console.error("Error revoking consent:", error);
      setRevokeReasonError(error.message || "Failed to revoke consent.");
    }
  };

  const sampleHistoryColumns = [
    {
      field: "sampleBarcodeId",
      headerName: "Barcode ID",
      width: 140,
    },
    {
      field: "sampleType",
      headerName: "Sample Type",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "collectionDate",
      headerName: "Collection Date",
      width: 140,
    },
    {
      field: "totalAliquotsCreated",
      headerName: "Total Aliquots Created",
      width: 180,
    },
  ];

  const patientActivityColumns = [
    {
      field: "activity",
      headerName: "Activity",
      flex: 1,
      minWidth: 280,
    },
    {
      field: "date",
      headerName: "Date",
      width: 140,
    },
    {
      field: "time",
      headerName: "Time",
      width: 120,
    },
  ];

  const renderConsentEntry = (item, keyPrefix) => {
    const consentKey = item.currentConsentId || item.consentName;
    const isUploading = uploadingConsentId === consentKey;

    // For styling/labels, item.status from backend (ACTIVE, NOT_SIGNED, EXPIRED, REVOKED)
    let displayStatus =
      item.status === "ACTIVE"
        ? "Active"
        : item.status === "NOT_SIGNED"
          ? "Not Signed"
          : item.status === "REVOKED"
            ? "Revoked"
            : item.status === "DUPLICATE"
              ? "Duplicate"
              : item.status === "EXPIRED"
                ? "Expired"
                : item.status;
    let bgColor =
      item.status === "ACTIVE"
        ? "#4CAF50"
        : item.status === "NOT_SIGNED"
          ? "#f57c00"
          : "#c62828";
    if (item.status === "REVOKED" || item.status === "DUPLICATE") {
      bgColor = "#9e9e9e";
    }

    const hasExtractedData = Boolean(item.activeRecord?.extractedSignerName);

    return (
      <Box key={keyPrefix || consentKey}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            py: 1,
          }}
        >
          <ChevronRightIcon sx={{ color: "#500000", fontSize: 20 }} />
          <Typography variant="body1" sx={{ color: "#333", flex: 1 }}>
            {item.irbStudy
              ? `${item.irbStudy}: ${item.consentName}`
              : item.consentName}
          </Typography>
          <Chip
            label={displayStatus}
            size="small"
            sx={{
              backgroundColor: bgColor,
              color: "white",
              fontWeight: 600,
              fontSize: "0.75rem",
            }}
          />
        </Box>

        <Box
          sx={{
            mt: 1,
            ml: 3,
            p: 2,
            border: "1px solid #eee",
            borderRadius: 2,
            backgroundColor: item.status === "REVOKED" ? "#f5f5f5" : "#fafafa",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Stack spacing={0.75} sx={{ minWidth: 260 }}>
              <Typography
                variant="body2"
                sx={{
                  color:
                    item.status === "REVOKED" ? "#c62828" : "textSecondary",
                  fontWeight: item.status === "REVOKED" ? 600 : 400,
                }}
              >
                {item.status === "REVOKED"
                  ? "Status: Revoked"
                  : `Consent Status: ${displayStatus}`}
              </Typography>
              {item.statusReason && (
                <Typography variant="body2" color="textSecondary">
                  Reason: {item.statusReason}
                </Typography>
              )}
              {item.status === "ACTIVE" && item.activeRecord && (
                <>
                  <Typography variant="body2" color="textSecondary">
                    Signer:{" "}
                    {item.activeRecord.extractedSignerName || "Not captured"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Signed Date:{" "}
                    {formatDateTime(
                      item.activeRecord.extractedSignedDate ||
                        item.activeRecord.consentDate,
                    )}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Source:{" "}
                    {item.activeRecord.signatureSourceType || "Not captured"}
                  </Typography>
                  {item.activeRecord.signatureMetadata &&
                    parseMetadataJson(item.activeRecord.signatureMetadata)
                      ?.protocolName && (
                      <Typography variant="body2" color="textSecondary">
                        Protocol:{" "}
                        {
                          parseMetadataJson(item.activeRecord.signatureMetadata)
                            .protocolName
                        }
                      </Typography>
                    )}
                  {item.activeRecord.expiresAt && (
                    <Typography variant="body2" color="textSecondary">
                      Expires: {formatDateTime(item.activeRecord.expiresAt)}
                    </Typography>
                  )}
                </>
              )}
            </Stack>

            <Stack direction="row" spacing={1} alignItems="flex-start">
              {item.status === "ACTIVE" && (
                <>
                  {hasExtractedData ? (
                    <>
                      <Button
                        variant="outlined"
                        size="small"
                        disabled
                        startIcon={<UploadFileIcon />}
                        sx={{
                          textTransform: "none",
                          color: "#9e9e9e",
                          borderColor: "#d0d0d0",
                        }}
                      >
                        Uploaded
                      </Button>
                      <Button
                        component="label"
                        variant="text"
                        size="small"
                        startIcon={
                          isUploading ? <CircularProgress size={16} /> : null
                        }
                        disabled={
                          (!item.currentConsentId &&
                            item.consentType !== "GENERAL") ||
                          isUploading
                        }
                        sx={{
                          textTransform: "none",
                          color: "#500000",
                          "&:hover": {
                            backgroundColor: "rgba(80, 0, 0, 0.08)",
                          },
                        }}
                      >
                        {isUploading ? "Parsing PDF..." : "Replace"}
                        <input
                          hidden
                          type="file"
                          accept="application/pdf,.pdf"
                          onChange={(event) =>
                            handleConsentPdfSelected(item, event)
                          }
                        />
                      </Button>
                    </>
                  ) : (
                    <Button
                      component="label"
                      variant="outlined"
                      size="small"
                      startIcon={
                        isUploading ? (
                          <CircularProgress size={16} />
                        ) : (
                          <UploadFileIcon />
                        )
                      }
                      disabled={
                        (!item.currentConsentId &&
                          item.consentType !== "GENERAL") ||
                        isUploading
                      }
                      sx={{
                        textTransform: "none",
                        color: "#500000",
                        borderColor: "#500000",
                        "&:hover": {
                          backgroundColor: "#500000",
                          color: "white",
                          borderColor: "#500000",
                        },
                      }}
                    >
                      {isUploading ? "Parsing PDF..." : "Upload Signed PDF"}
                      <input
                        hidden
                        type="file"
                        accept="application/pdf,.pdf"
                        onChange={(event) =>
                          handleConsentPdfSelected(item, event)
                        }
                      />
                    </Button>
                  )}
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleRevokeClick(item)}
                    disabled={!item.signed}
                    sx={{
                      textTransform: "none",
                      color: "#c62828",
                      borderColor: "#c62828",
                      "&:hover": {
                        backgroundColor: "#c62828",
                        color: "white",
                        borderColor: "#c62828",
                      },
                    }}
                  >
                    Revoke Consent
                  </Button>
                </>
              )}

              {item.status !== "ACTIVE" && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => handleOpenSignModal(item)}
                  sx={{
                    textTransform: "none",
                    color: "#500000",
                    borderColor: "#500000",
                    "&:hover": {
                      backgroundColor: "#500000",
                      color: "white",
                      borderColor: "#500000",
                    },
                  }}
                >
                  Sign
                </Button>
              )}
            </Stack>
          </Box>
        </Box>
      </Box>
    );
  };

  const renderContactInformation = () => (
    <Box>
      {contactError && (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          onClose={() => setContactError("")}
        >
          {contactError}
        </Alert>
      )}
      {contactSuccess && (
        <Alert
          severity="success"
          sx={{ mb: 2 }}
          onClose={() => setContactSuccess("")}
        >
          {contactSuccess}
        </Alert>
      )}

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h6" sx={{ color: "#500000", fontWeight: 600 }}>
          Contact Information
        </Typography>
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={handleEditContact}
          sx={{
            color: "#500000",
            borderColor: "#500000",
            "&:hover": {
              backgroundColor: "#500000",
              color: "white",
              borderColor: "#500000",
            },
          }}
        >
          Edit
        </Button>
      </Box>

      {loadingContactInfo ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress sx={{ color: "#500000" }} />
        </Box>
      ) : (
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 3 }}>
          <Box>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Email Address
            </Typography>
            <Typography variant="body1">{patient?.email || "—"}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Mobile Phone Number
            </Typography>
            <Typography variant="body1">
              {patient?.mobilePhoneNumber || "—"}
            </Typography>
          </Box>
          <Box sx={{ gridColumn: "span 2" }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Home Address
            </Typography>
            <Typography variant="body1">
              {patient?.homeAddressLine1 ? (
                <>
                  {patient.homeAddressLine1}
                  {patient.homeAddressLine2 && `, ${patient.homeAddressLine2}`}
                  <br />
                  {patient.city && `${patient.city}, `}
                  {patient.state && `${patient.state} `}
                  {patient.zipCode}
                </>
              ) : (
                "—"
              )}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );

  const renderConsentFormsAndSurveys = () => (
    <Box sx={{ display: "flex", gap: 4 }}>
      {/* Sidebar Navigation */}
      <Box sx={{ width: 240, flexShrink: 0 }}>
        <List sx={{ p: 0 }}>
          <ListItem
            button
            selected={subTabValue === 0}
            onClick={() => setSubTabValue(0)}
            sx={{
              borderRadius: 1,
              mb: 1,
              backgroundColor: subTabValue === 0 ? "#500000" : "transparent",
              color: subTabValue === 0 ? "white" : "inherit",
              "&:hover": {
                backgroundColor: subTabValue === 0 ? "#500000" : "#f5f5f5",
              },
            }}
          >
            <ListItemText
              primary="STUDY CONSENT"
              sx={{
                textAlign: "center",
                "& .MuiListItemText-primary": {
                  color: subTabValue === 0 ? "white" : "#666",
                  fontWeight: 600,
                },
              }}
            />
          </ListItem>
          <ListItem
            button
            selected={subTabValue === 1}
            onClick={() => setSubTabValue(1)}
            sx={{
              borderRadius: 1,
              mb: 1,
              backgroundColor: subTabValue === 1 ? "#500000" : "transparent",
              color: subTabValue === 1 ? "white" : "inherit",
              "&:hover": {
                backgroundColor: subTabValue === 1 ? "#500000" : "#f5f5f5",
              },
            }}
          >
            <ListItemText
              primary="GENERAL CONSENT"
              sx={{
                textAlign: "center",
                "& .MuiListItemText-primary": {
                  color: subTabValue === 1 ? "white" : "#666",
                  fontWeight: 600,
                },
              }}
            />
          </ListItem>
          <ListItem
            button
            selected={subTabValue === 2}
            onClick={() => setSubTabValue(2)}
            sx={{
              borderRadius: 1,
              backgroundColor: subTabValue === 2 ? "#500000" : "transparent",
              color: subTabValue === 2 ? "white" : "inherit",
              "&:hover": {
                backgroundColor: subTabValue === 2 ? "#500000" : "#f5f5f5",
              },
            }}
          >
            <ListItemText
              primary="SURVEYS"
              sx={{
                textAlign: "center",
                "& .MuiListItemText-primary": {
                  color: subTabValue === 2 ? "white" : "#666",
                  fontWeight: 600,
                },
              }}
            />
          </ListItem>
        </List>
      </Box>

      {/* Main Content */}
      <Box sx={{ flex: 1 }}>
        {subTabValue === 0 && (
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
                Study Consent:
              </Typography>
              <Button
                variant="contained"
                size="small"
                onClick={() =>
                  navigate(
                    BIOBANK_SUB_ROUTES.PARTICIPANT_CHECKIN_WIZARD_CONSENT,
                    { state: { patient, nextStep: location.pathname } },
                  )
                }
                sx={{
                  textTransform: "none",
                  backgroundColor: "#500000",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#400000",
                  },
                }}
              >
                Sign All Consents
              </Button>
            </Box>
            {consentActionError && (
              <Alert
                severity="error"
                sx={{ mb: 2 }}
                onClose={() => setConsentActionError("")}
              >
                {consentActionError}
              </Alert>
            )}
            {consentActionSuccess && (
              <Alert
                severity="success"
                sx={{ mb: 2 }}
                onClose={() => setConsentActionSuccess("")}
              >
                {consentActionSuccess}
              </Alert>
            )}

            {loadingConsents ? (
              <Typography variant="body2" color="textSecondary">
                Loading study consents...
              </Typography>
            ) : (
              <Stack spacing={4}>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: "#333", mb: 1 }}
                  >
                    Active
                  </Typography>
                  {consentOverview.studyConsent.active.length > 0 ? (
                    <Stack spacing={2} sx={{ mb: 3 }}>
                      {consentOverview.studyConsent.active.map((item, idx) =>
                        renderConsentEntry(item, `study-active-${idx}`),
                      )}
                    </Stack>
                  ) : (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mb: 3, ml: 2 }}
                    >
                      No active study consents.
                    </Typography>
                  )}

                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: "#333", mb: 1 }}
                  >
                    Inactive / Missing
                  </Typography>
                  {consentOverview.studyConsent.inactive.length > 0 ? (
                    <Stack spacing={2} sx={{ mb: 3 }}>
                      {consentOverview.studyConsent.inactive.map((item, idx) =>
                        renderConsentEntry(item, `study-inactive-${idx}`),
                      )}
                    </Stack>
                  ) : (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mb: 3, ml: 2 }}
                    >
                      No inactive study consents.
                    </Typography>
                  )}
                </Box>
              </Stack>
            )}
          </Box>
        )}

        {subTabValue === 1 && (
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
                General Consent:
              </Typography>
              <Button
                variant="contained"
                size="small"
                onClick={() =>
                  navigate(
                    BIOBANK_SUB_ROUTES.PARTICIPANT_CHECKIN_WIZARD_CONSENT,
                    { state: { patient, nextStep: location.pathname } },
                  )
                }
                sx={{
                  textTransform: "none",
                  backgroundColor: "#500000",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#400000",
                  },
                }}
              >
                Sign All Consents
              </Button>
            </Box>
            {consentActionError && (
              <Alert
                severity="error"
                sx={{ mb: 2 }}
                onClose={() => setConsentActionError("")}
              >
                {consentActionError}
              </Alert>
            )}
            {consentActionSuccess && (
              <Alert
                severity="success"
                sx={{ mb: 2 }}
                onClose={() => setConsentActionSuccess("")}
              >
                {consentActionSuccess}
              </Alert>
            )}

            {loadingConsents ? (
              <Typography variant="body2" color="textSecondary">
                Loading general consents...
              </Typography>
            ) : (
              <Stack spacing={4}>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: "#333", mb: 1 }}
                  >
                    Active
                  </Typography>
                  {consentOverview.generalConsent.active.length > 0 ? (
                    <Stack spacing={2} sx={{ mb: 3 }}>
                      {consentOverview.generalConsent.active.map((item, idx) =>
                        renderConsentEntry(item, `general-active-${idx}`),
                      )}
                    </Stack>
                  ) : (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mb: 3, ml: 2 }}
                    >
                      No active general consents.
                    </Typography>
                  )}

                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: "#333", mb: 1 }}
                  >
                    Inactive / Missing
                  </Typography>
                  {consentOverview.generalConsent.inactive.length > 0 ? (
                    <Stack spacing={2} sx={{ mb: 3 }}>
                      {consentOverview.generalConsent.inactive.map(
                        (item, idx) =>
                          renderConsentEntry(item, `general-inactive-${idx}`),
                      )}
                    </Stack>
                  ) : (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mb: 3, ml: 2 }}
                    >
                      No inactive general consents.
                    </Typography>
                  )}
                </Box>
              </Stack>
            )}
          </Box>
        )}

        {subTabValue === 2 && (
          <Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, mb: 2, color: "#333" }}
            >
              Patient Surveys:
            </Typography>
            <Typography variant="body1" color="text.secondary">
              No surveys available at this time.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );

  const renderPatientActivity = () => {
    const activityRows = patientActivity.map((item, index) => ({
      id: index + 1,
      activity: item.activity ?? "—",
      date: item.date ?? "—",
      time: item.time ?? "—",
    }));
    return (
      <Box sx={{ height: 400, width: "100%" }}>
        {loadingActivity ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <Typography color="textSecondary">Loading activity...</Typography>
          </Box>
        ) : activityRows.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <Typography color="textSecondary">
              No activity data available.
            </Typography>
          </Box>
        ) : (
          <StyledDataGrid
            rows={activityRows}
            columns={patientActivityColumns}
            pageSizeOptions={[10, 25, 50, 100]}
            pagination
            disableSelectionOnClick
            initialState={{
              pagination: {
                paginationModel: { pageSize: 25 },
              },
            }}
          />
        )}
      </Box>
    );
  };

  const renderSampleHistory = () => {
    const historyRows = sampleHistory.map((item, index) => ({
      id: index + 1,
      sampleBarcodeId: item.sampleBarcodeId ?? "—",
      sampleType: item.sampleType ?? "—",
      collectionDate: item.collectionDate ?? "—",
      totalAliquotsCreated: item.totalAliquotsCreated ?? 0,
    }));
    return (
      <Box sx={{ height: 400, width: "100%" }}>
        {loadingSampleHistory ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <Typography color="textSecondary">
              Loading sample history...
            </Typography>
          </Box>
        ) : historyRows.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <Typography color="textSecondary">
              No sample history available.
            </Typography>
          </Box>
        ) : (
          <StyledDataGrid
            rows={historyRows}
            columns={sampleHistoryColumns}
            pageSizeOptions={[10, 25, 50, 100]}
            pagination
            disableSelectionOnClick
            initialState={{
              pagination: {
                paginationModel: { pageSize: 25 },
              },
            }}
          />
        )}
      </Box>
    );
  };

  const renderConsentMetadataReviewDialog = () => {
    const signerMatchesPatient = namesMatch(
      reviewValues.signerName,
      patient?.name,
    );
    const showNameMismatchWarning =
      reviewValues.signerName && patient?.name && !signerMatchesPatient;
    const requiresManualEntry = parsedConsentMetadata?.requiresManualEntry;
    const sourceType = requiresManualEntry
      ? "MANUAL_ENTRY"
      : parsedConsentMetadata?.sourceType || "ADOBE_ESIGNED";
    const additionalSigners = (parsedConsentMetadata?.signers || []).filter(
      (signer) => signer.name !== reviewValues.signerName,
    );

    return (
      <Dialog
        open={reviewDialogOpen}
        onClose={handleCloseReviewDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle sx={{ color: "#500000", fontWeight: 700 }}>
          Review Consent Metadata
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            {requiresManualEntry ? (
              <Alert severity="warning">
                This PDF was not recognized as an Adobe e-signed PDF. Please
                enter the consent metadata manually before saving.
              </Alert>
            ) : (
              <Alert severity="success">
                Adobe e-signed PDF parsed successfully. Please review and
                confirm the extracted values.
              </Alert>
            )}

            {consentActionError && (
              <Alert severity="error" onClose={() => setConsentActionError("")}>
                {consentActionError}
              </Alert>
            )}

            {showNameMismatchWarning && (
              <Alert severity="error">
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  Strong warning: signer name does not match this participant.
                </Typography>
                <Typography variant="body2">
                  Participant: {patient.name}
                </Typography>
                <Typography variant="body2">
                  PDF/entered signer: {reviewValues.signerName}
                </Typography>
              </Alert>
            )}

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 2,
              }}
            >
              <TextField
                label="Subject Signer Name"
                value={reviewValues.signerName}
                onChange={handleReviewValueChange("signerName")}
                required
                fullWidth
              />
              <TextField
                label="Signed Date"
                type="datetime-local"
                value={reviewValues.signedDate}
                onChange={handleReviewValueChange("signedDate")}
                required
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="IRB Study"
                value={reviewValues.irbStudy}
                onChange={handleReviewValueChange("irbStudy")}
                required
                fullWidth
              />
              <TextField
                label="Protocol Name"
                value={reviewValues.protocolName}
                onChange={handleReviewValueChange("protocolName")}
                fullWidth
              />
            </Box>

            <Box
              sx={{
                p: 2,
                border: "1px solid #eee",
                borderRadius: 2,
                backgroundColor: "#fafafa",
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                Parse Details
              </Typography>
              <Stack
                direction="row"
                spacing={1}
                sx={{ flexWrap: "wrap", gap: 1 }}
              >
                <Chip
                  label={`Source: ${sourceType}`}
                  size="small"
                  sx={{ ...BASE_CHIP_SX, ...STATUS_CHIP_STYLES.default }}
                />
                <Chip
                  label={`Confidence: ${parsedConsentMetadata?.confidence || "Manual"}`}
                  size="small"
                  sx={{
                    ...BASE_CHIP_SX,
                    ...(parsedConsentMetadata?.confidence === "HIGH"
                      ? STATUS_CHIP_STYLES.success
                      : STATUS_CHIP_STYLES.warning),
                  }}
                />
                <Chip
                  label={`Manual Entry: ${requiresManualEntry ? "Yes" : "No"}`}
                  size="small"
                  sx={{
                    ...BASE_CHIP_SX,
                    ...(requiresManualEntry
                      ? STATUS_CHIP_STYLES.warning
                      : STATUS_CHIP_STYLES.success),
                  }}
                />
              </Stack>

              {additionalSigners.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Additional Signers
                  </Typography>
                  {additionalSigners.map((signer, index) => (
                    <Typography
                      key={`${signer.name}-${index}`}
                      variant="body2"
                      color="textSecondary"
                    >
                      {signer.name} · {signer.role || "unknown role"} ·{" "}
                      {formatDateTime(signer.signedAt)}
                    </Typography>
                  ))}
                </Box>
              )}

              {parsedConsentMetadata?.warnings?.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Warnings
                  </Typography>
                  {parsedConsentMetadata.warnings.map((warning, index) => (
                    <Typography key={index} variant="body2" color="error">
                      {warning}
                    </Typography>
                  ))}
                </Box>
              )}
            </Box>

            {showNameMismatchWarning && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mismatchAcknowledged}
                    onChange={(event) =>
                      setMismatchAcknowledged(event.target.checked)
                    }
                  />
                }
                label="I understand the signer name does not match the participant and still want to save this consent metadata."
              />
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleCloseReviewDialog}
            disabled={savingConsentMetadata}
            sx={{ textTransform: "none", color: "#500000" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmConsentMetadata}
            disabled={
              savingConsentMetadata ||
              !reviewValues.signerName ||
              !reviewValues.signedDate ||
              !reviewValues.irbStudy ||
              (showNameMismatchWarning && !mismatchAcknowledged)
            }
            sx={{
              textTransform: "none",
              backgroundColor: "#500000",
              "&:hover": { backgroundColor: "#400000" },
            }}
          >
            {savingConsentMetadata ? (
              <>
                <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                Saving...
              </>
            ) : (
              "Confirm & Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderRevokeConsentDialog = () => {
    const todayFormatted = new Date().toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    return (
      <Dialog
        open={revokeDialogOpen}
        onClose={handleCloseRevokeDialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: "#500000", fontWeight: 700 }}>
          Revoke Consent?
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            You are about to revoke{" "}
            {revokeTarget?.name ? `"${revokeTarget.name}"` : "this"} consent
            effective today ({todayFormatted}).
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            This action will revoke this consent permanently. A new consent must
            be signed to participate again.
          </Typography>
          <TextField
            label="Reason for revocation"
            placeholder="Enter the reason this consent is being revoked"
            value={revokeReason}
            onChange={handleRevokeReasonChange}
            required
            fullWidth
            multiline
            minRows={2}
            error={Boolean(revokeReasonError)}
            helperText={
              revokeReasonError ||
              "This reason will be saved as part of the revocation record."
            }
            sx={{ mb: 1.5 }}
          />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Are you sure you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleCloseRevokeDialog}
            sx={{ textTransform: "none", color: "#500000" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmRevoke}
            disabled={!revokeReason.trim()}
            sx={{
              textTransform: "none",
              backgroundColor: "#c62828",
              "&:hover": { backgroundColor: "#8e0000" },
            }}
          >
            Revoke
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderEditContactDialog = () => (
    <Dialog
      open={editingContact}
      onClose={handleCancelContactEdit}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ color: "#500000", fontWeight: 700 }}>
        Edit Contact Information
      </DialogTitle>
      <DialogContent>
        {contactError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {contactError}
          </Alert>
        )}
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Email"
            fullWidth
            value={contactInfo.email}
            onChange={handleContactFieldChange("email")}
            type="email"
          />
          <TextField
            label="Mobile Phone"
            fullWidth
            value={contactInfo.mobilePhoneNumber}
            onChange={handleContactFieldChange("mobilePhoneNumber")}
          />
          <TextField
            label="Address Line 1"
            fullWidth
            value={contactInfo.homeAddressLine1}
            onChange={handleContactFieldChange("homeAddressLine1")}
          />
          <TextField
            label="Address Line 2"
            fullWidth
            value={contactInfo.homeAddressLine2}
            onChange={handleContactFieldChange("homeAddressLine2")}
          />
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="City"
              fullWidth
              value={contactInfo.city}
              onChange={handleContactFieldChange("city")}
            />
            <TextField
              select
              label="State"
              fullWidth
              value={contactInfo.state}
              onChange={handleContactFieldChange("state")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {US_STATES.map((state) => (
                <MenuItem key={state.value} value={state.value}>
                  {state.label}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label="Zip Code"
              fullWidth
              value={contactInfo.zipCode}
              onChange={handleContactFieldChange("zipCode")}
            />
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={handleCancelContactEdit}
          sx={{ textTransform: "none", color: "#500000" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSaveContactInfo}
          disabled={savingContact}
          sx={{
            textTransform: "none",
            backgroundColor: "#500000",
            "&:hover": { backgroundColor: "#400000" },
          }}
        >
          {savingContact ? "Saving..." : "Save Changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );

  if (!patient) {
    return <Box>Loading...</Box>;
  }

  return (
    <RecordProfilePage
      title="Participant Profile"
      backTo="/admin/patient-data"
      maxWidth={1200}
    >
      {/* Participant Information Card */}
      <Card
        sx={{
          mb: 3,
          borderRadius: 2,
          boxShadow: "none",
          border: "1px solid #e0e0e0",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            <Avatar
              sx={{
                width: 80,
                height: 80,
                backgroundColor: "#500000",
                fontSize: "2rem",
                fontWeight: 600,
                color: "white",
              }}
            >
              {patient.initials}
            </Avatar>
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 2,
                  color: "#500000",
                  fontSize: "2rem",
                }}
              >
                {patient.name}
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
                  >
                    Active Since:
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    {patient.activeSince}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
                  >
                    Date of Birth:
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    {formatDateOnly(patient.dateOfBirth)}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
                  >
                    Alzheimer's Status:
                  </Typography>
                  {patient.alzheimersStatus ? (
                    <Chip
                      label={
                        ALZHEIMERS_STATUS_LABELS[patient.alzheimersStatus] ||
                        patient.alzheimersStatus
                      }
                      size="small"
                      sx={{
                        ...BASE_CHIP_SX,
                        ...getStatusChipStyle(patient.alzheimersStatus),
                      }}
                    />
                  ) : (
                    <Typography variant="body2" sx={{ color: "#666" }}>
                      —
                    </Typography>
                  )}
                </Box>
                <Box sx={{ minWidth: "200px" }}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
                  >
                    Participation:
                  </Typography>
                  <Stack spacing={0.5}>
                    {patient.irbStudies.map((study) => (
                      <Typography
                        key={study.id}
                        variant="body2"
                        sx={{ color: "#666" }}
                      >
                        {study.id}
                        {study.status
                          ? `: ${study.status}`
                          : study.name !== study.id
                            ? `: ${study.name}`
                            : ""}
                      </Typography>
                    ))}
                  </Stack>
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
                  >
                    Date of Last Visit:
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    {formatDateOnly(patient.lastVisit)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Tab Content Card */}
      <Card
        sx={{
          borderRadius: 2,
          boxShadow: "none",
          border: "1px solid #e0e0e0",
          minHeight: 400,
        }}
      >
        {/* Navigation Tabs */}
        <Box sx={{ p: 3, pb: 0 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.875rem",
                px: 2,
                py: 1,
                borderRadius: "20px",
                marginRight: 3,
                minHeight: "auto",
                backgroundColor: "transparent",
                color: "#500000",
                border: "1px solid #500000",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
              },
              "& .Mui-selected": {
                backgroundColor: "#500000 !important",
                color: "white !important",
                "&:hover": {
                  backgroundColor: "#400000 !important",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            <Tab label="CONTACT INFORMATION" />
            <Tab label="CONSENT FORMS & SURVEYS" />
            <Tab label="PARTICIPANT ACTIVITY" />
            <Tab label="SAMPLE HISTORY" />
            <Tab label="GENOMIC REPORTS" />
          </Tabs>
          <Divider sx={{ mt: 2 }} />
        </Box>

        <CardContent sx={{ p: 3, pt: 2 }}>
          {tabValue === 0 && renderContactInformation()}
          {tabValue === 1 && renderConsentFormsAndSurveys()}
          {tabValue === 2 && renderPatientActivity()}
          {tabValue === 3 && renderSampleHistory()}
          {tabValue === 4 && <GenomicReportsTab patient={patient} />}
        </CardContent>
      </Card>
      {renderConsentMetadataReviewDialog()}
      {renderRevokeConsentDialog()}
      {renderEditContactDialog()}

      <Dialog
        open={confirmSignModalOpen}
        onClose={() => !isSigningConsent && setConfirmSignModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ color: "#500000", fontWeight: 600 }}>
          Confirm Consents Selection
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Clicking Confirm & Continue indicates you have received the
            participant's signed paper consent form(s) for the following:
          </Typography>
          <Box sx={{ mt: 2, pl: 2 }}>
            <ul style={{ margin: 0 }}>
              <li>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#3E3E3E" }}
                >
                  {consentToSign?.consentName || consentToSign?.id}
                  {consentToSign?.irbStudy
                    ? ` (${consentToSign.irbStudy})`
                    : ""}
                </Typography>
              </li>
            </ul>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={() => setConfirmSignModalOpen(false)}
            variant="outlined"
            disabled={isSigningConsent}
            sx={{ borderColor: "#500000", color: "#500000" }}
          >
            Go Back
          </Button>
          <Button
            onClick={handleConfirmSign}
            variant="contained"
            disabled={isSigningConsent}
            sx={{
              backgroundColor: "#500000",
              "&:hover": { backgroundColor: "#3a0000" },
            }}
          >
            {isSigningConsent ? "Saving..." : "Yes, Continue"}
          </Button>
        </DialogActions>
      </Dialog>
    </RecordProfilePage>
  );
};

export default PatientProfile;
